import { TENANTS_LIST } from "constants/index";

export default (locale, projectID, currentTenant) => {
    const metaTags = {
        "DE-HH-04": {
            ogURL: "/marketplace/DE-HH-04",
            ogTitle: locale === "en" ? "Lakeside! Jenfeld | Real Estate investment" : "Lakeside! Jenfeld | Immobilieninvestment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY is realizing the next digital real estate investment with Lakeside! Jenfeld'. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit dem Projekt Lakeside! Jenfeld das nächste digitale Immobilieninvestment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Lakeside_Jenfeld_2021_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Lakeside_Jenfeld_2021_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Lakeside_Jenfeld_2021_OG.png`,
        },
        "DE-K-01": {
            ogURL: "/marketplace/DE-K-01",
            ogTitle: locale === "en" ? "Cologne One! | Real Estate Investment" : "Cologne One! | Immobilieninvestment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY launches the first real estate project in the Rhine metropolis Cologne on the platform. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY bringt das erste Immobilienprojekt in der Rheinmetropole Köln auf die Plattform. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Cologne_One_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Cologne_One_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Cologne_One_OG.png`,
        },
        "DE-HH-06": {
            ogURL: "/marketplace/DE-HH-06",
            ogTitle: locale === "en" ? "Börnestraße! | Real Estate Investment" : "Börnestraße! | Immobilieninvestment",
            ogDescription:
                locale === "en"
                    ? "With Börnestraße! Eilbek, FINEXITY launches the next real estate project in Hamburg on the platform. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY bringt mit Börnestraße! Eilbek das nächste Immobilienprojekt in Hamburg auf die Plattform. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Boernestrasse_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Boernestrasse_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Boernestrasse_OG.png`,
        },
        "ES-MA-01": {
            ogURL: "/marketplace/ES-MA-01",
            ogTitle: locale === "en" ? "White Bay! Marbella | Holiday Apartments" : "White Bay! Marbella | Ferienimmobilie",
            ogDescription:
                locale === "en"
                    ? "FINEXITY expands its product offering with holiday apartments in Marbella, including a fixed minimum interest rate and a maximum term of 36 months."
                    : "FINEXITY erweitert sein Produktangebot um eine Ferienimmobilie in Marbella mit einer festen Mindestverzinsung und max. 36 Monaten Laufzeit.",
            ogImage: `/docs/social/FINEXITY_White_Bay_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_White_Bay_OG.png`,
            twitterImage: `/docs/social/FINEXITY_White_Bay_OG.png`,
        },
        "GB-AW-01": {
            ogURL: "/marketplace/GB-AW-01",
            ogTitlt:
                locale === "en"
                    ? "Andy Warhol - Vegetarian Vegetable (1969) | Art investment"
                    : "Andy Warhol – Vegetarian Vegetable (1969) | Kunstinvestment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realizes Europe's first digital art investment with an artist's copy of Andy Warhol's 'Vegetarian Vegetable (1969)' from the world-famous series of Campbell’s soup cans. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit einem Künstlerexemplar von Andy Warhols „Vegetarian Vegetable (1969)” aus der weltweit bekannten Serie von Campbell’s Suppendosen Europas erstes digitales Kunstinvestment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/VegetarianVegetablesOG.png`,
            ogImageURL: `/docs/social/VegetarianVegetablesOG.png`,
            twitterImage: `/docs/social/VegetarianVegetablesOG.png`,
        },
        "DE-GU-01": {
            ogURL: "/marketplace/DE-GU-01",
            ogTitle:
                locale === "en"
                    ? "Günther Uecker - Homage to Hafez (2015) | Art investment"
                    : "Günther Uecker – Huldigung an Hafez (2015) | Kunstinvestment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY is realizing the next digital art investment with Günther Uecker's artist folder 'Homage to Hafez (2015)'. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit der Künstlermappe 'Huldigung an Hafez (2015)' von Günther Uecker das nächste digitale Kunstinvestment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/Guenther_Uecker_Huldigung_an_Hafez_VG_Bild-Kunst_Bonn_2021_OG.png`,
            ogImageURL: `/docs/social/Guenther_Uecker_Huldigung_an_Hafez_VG_Bild-Kunst_Bonn_2021_OG.png`,
            twitterImage: `/docs/social/Guenther_Uecker_Huldigung_an_Hafez_VG_Bild-Kunst_Bonn_2021_OG.png`,
        },
        "DE-HM-01": {
            ogURL: "/marketplace/DE-HM-01",
            ogTitle:
                locale === "en"
                    ? "Heinz Mack - 12 Stunden (2016) | Art investment"
                    : "Heinz Mack - 12 Stunden (2016) | Kunstinvestment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY expands its art collection with the artist portfolio '12 Stunden (2016)' by Heinz Mack. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY erweitert mit der Künstlermappe '12 Stunden (2016)' von Heinz Mack ihre Kunstsammlung. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/Heinz_Mack_12_Stunden_VG_Bild-Kunst_Bonn_2021_OG.png`,
            ogImageURL: `/docs/social/Heinz_Mack_12_Stunden_VG_Bild-Kunst_Bonn_2021_OG.png`,
            twitterImage: `/docs/social/Heinz_Mack_12_Stunden_VG_Bild-Kunst_Bonn_2021_OG.png`,
        },
        "DE-TC-01": {
            ogURL: "/marketplace/DE-TC-01",
            ogTitle: locale === "en" ? "Tony Cragg - Ivy (2018) | Art investment" : "Tony Cragg - Ivy (2018) | Kunstinvestment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY expands its art collection with the bronze sculpture 'Ivy (2018)' by Tony Cragg. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY erweitert mit der Bronzeskulptur 'Ivy (2018)' von Tony Cragg ihre Kunstsammlung. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/Tony_Cragg_Ivy_VG_Bild-Kunst_Bonn_2021_OG.png`,
            ogImageURL: `/docs/social/Tony_Cragg_Ivy_VG_Bild-Kunst_Bonn_2021_OG.png`,
            twitterImage: `/docs/social/Tony_Cragg_Ivy_VG_Bild-Kunst_Bonn_2021_OG.png`,
        },
        "DE-CH-01": {
            ogURL: "/marketplace/DE-CH-01",
            ogTitle: "Château Lafite Rothschild Special Collection (2018) | Fine Wine",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine wine investment with Château Lafite Rothschild (2018). Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit dem Château Lafite Rothschild (2018) das nächste Fine Wine Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/Christo_Arc_de_Triomphe_Wrapped_2019_OG.png`,
            ogImageURL: `/docs/social/Christo_Arc_de_Triomphe_Wrapped_2019_OG.png`,
            twitterImage: `/docs/social/Christo_Arc_de_Triomphe_Wrapped_2019_OG.png`,
        },
        "DE-ML-01": {
            ogURL: "/marketplace/DE-ML-01",
            ogTitle:
                locale === "en"
                    ? "Markus Lüpertz – Sternzeichen (2018) | Art Investment"
                    : "Markus Lüpertz – Sternzeichen (2018) | Kunstinvestment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY expands its art collection with the sculptures and graphics 'Sternzeichen (2018)' by Markus Lüpertz."
                    : "FINEXITY erweitert mit den Skulpturen und Grafiken 'Sternzeichen (2018)' von Markus Lüpertz ihre Kunstsammlung.",
            ogImage: `/docs/social/FINEXITY_Markus_Luepertz_Sternzeichen_2018_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Markus_Luepertz_Sternzeichen_2018_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Markus_Luepertz_Sternzeichen_2018_OG.png`,
        },
        "DE-KH-01": {
            ogURL: "/marketplace/DE-KH-01",
            ogTitle:
                locale === "en"
                    ? "Keith Haring – Untitled (Free South Africa), 1985 | Art Investment"
                    : "Keith Haring – Untitled (Free South Africa), 1985 | Kunstinvestment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY expands its art collection with the artist's print series 'Untitled (Free South Africa), 1985' by Keith Haring."
                    : "FINEXITY erweitert mit der Artist's Print Serie 'Untitled (Free South Africa), 1985' von Keith Haring ihre Kunstsammlung.",
            ogImage: `/docs/social/FINEXITY_Keith_Haring_Untitled_FreeSouthAfrica_1985_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Keith_Haring_Untitled_FreeSouthAfrica_1985_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Keith_Haring_Untitled_FreeSouthAfrica_1985_OG.png`,
        },
        "DE-RC-01": {
            ogURL: "/marketplace/DE-RC-01",
            ogTitle: "Domaine de la Romanée-Conti Assortment Case (2016) | Fine Wine",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises Europe's first digital fine wine investment with the Domaine de la Romanée-Conti Assortment Case (2016)."
                    : "FINEXITY realisiert mit dem Domaine de la Romanée-Conti Assortment Case (2016) Europas erstes digitales Fine Wine Investment.",
            ogImage: `/docs/social/FINEXITY_DRC_2016_Assortment_Case.png`,
            ogImageURL: `/docs/social/FINEXITY_DRC_2016_Assortment_Case.png`,
            twitterImage: `/docs/social/FINEXITY_DRC_2016_Assortment_Case.png`,
        },
        "DE-CL-01": {
            ogURL: "/marketplace/DE-CL-01",
            ogTitle: "Château Lafite Rothschild Special Case (2018) | Fine Wine",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine wine investment with Château Lafite Rothschild (2018). Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit dem Château Lafite Rothschild (2018) das nächste Fine Wine Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Chateau_Lafite_Rothschild_2018_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Chateau_Lafite_Rothschild_2018_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Chateau_Lafite_Rothschild_2018_OG.png`,
        },
        "DE-LP-01": {
            ogURL: "/marketplace/DE-LP-01",
            ogTitle: "Château Le Pin Vertical Collection | Fine Wine",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine wine investment with the Château Le Pin Vertical Collection. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit der Château Le Pin Vertical Collection das nächste Fine Wine Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Le_Pin_Vertical_Collection_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Le_Pin_Vertical_Collection_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Le_Pin_Vertical_Collection_OG.png`,
        },
        "DE-OO-01": {
            ogURL: "/marketplace/DE-OO-01",
            ogTitle: "Rothschild Mondavi Opus One Magnum Collection (2015) | Fine Wine",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine wine investment with the Rothschild Mondavi Opus One Magnum Collection (2015). Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit der Rothschild Mondavi Opus One Magnum Collection (2015) das nächste Fine Wine Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Rothschild_Mondavi_Opus_One_2015_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Rothschild_Mondavi_Opus_One_2015_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Rothschild_Mondavi_Opus_One_2015_OG.png`,
        },
        "DE-SM-01": {
            ogURL: "/marketplace/DE-SM-01",
            ogTitle: "Salon Le Mesnil Champagne Magnum Collection (2008) | Fine Wine",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine wine investment with the Salon Le Mesnil Champagne Magnum Collection (2008). Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit der Salon Le Mesnil (2008) Champagner Magnum Collection das nächste Fine Wine Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Salon_Le_Mesnil_2008_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Salon_Le_Mesnil_2008_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Salon_Le_Mesnil_2008_OG.png`,
        },
        "DE-FP-01": {
            ogURL: "/marketplace/DE-FP-01",
            ogTitle: locale === "en" ? "Fancy Pink Diamond 1,01 ct | Diamonds" : "Fancy Pink Diamond 1,01 ct | Diamanten",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the first diamonds investment with a 1,01 ct Fancy Pink Diamond. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit einem 1,01 ct Fancy Pink Diamond das erste Diamanten-Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Fancy_Pink_Diamond_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Fancy_Pink_Diamond_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Fancy_Pink_Diamond_OG.png`,
        },
        "DE-AW-02": {
            ogURL: "/marketplace/DE-AW-02",
            ogTitle: locale === "en" ? "Andy Warhol – Cow, 1971 | Art Investment" : "Andy Warhol – Cow, 1971 | Kunstinvestment",
            ogDescription:
                locale === "en"
                    ? 'FINEXITY expands its art collection with the screen print "Cow, 1971" by Andy Warhol. Investors can participate in the form of investment tokens from 500 euros.'
                    : 'FINEXITY erweitert mit dem Siebdruck "Cow, 1971" von Andy Warhol ihre Kunstsammlung. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.',
            ogImage: `/docs/social/FINEXITY_Andy_Warhol_Cow_1971_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Andy_Warhol_Cow_1971_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Andy_Warhol_Cow_1971_OG.png`,
        },
        "DE-AW-03": {
            ogURL: "/marketplace/DE-AW-03",
            ogTitle:
                locale === "en"
                    ? "Andy Warhol – Jack Nicklaus, 1977 | Art Investment"
                    : "Andy Warhol – Jack Nicklaus, 1977 | Kunstinvestment",
            ogDescription:
                locale === "en"
                    ? 'FINEXITY expands its art collection with the unique screen print "Jack Nicklaus, 1977" by Andy Warhol. Investors can participate in the form of investment tokens from 500 euros.'
                    : 'FINEXITY erweitert mit dem Siebdruck "Jack Nicklaus, 1977" von Andy Warhol ihre Kunstsammlung. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.',
            ogImage: `/docs/social/FINEXITY_Andy_Warhol_Nicklaus_1977_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Andy_Warhol_Nicklaus_1977_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Andy_Warhol_Nicklaus_1977_OG.png`,
        },
        "DE-AK-01": {
            ogURL: "/marketplace/DE-AK-01",
            ogTitle:
                locale === "en"
                    ? "Alex Katz – Coca-Cola Girl, 2019 | Art Investment"
                    : "Alex Katz – Coca-Cola Girl, 2019 | Kunstinvestment",
            ogDescription:
                locale === "en"
                    ? 'FINEXITY expands its art collection with the graphic series "Coca-Cola Girl, 2019" by Alex Katz. Investors can participate in the form of investment tokens from 500 euros.'
                    : 'FINEXITY erweitert mit der Grafikserie "Coca-Cola Girl, 2019" von Alex Katz ihre Kunstsammlung. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.',
            ogImage: `/docs/social/FINEXITY_Alex_Katz_Coca_Cola_Girl_2019_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Alex_Katz_Coca_Cola_Girl_2019_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Alex_Katz_Coca_Cola_Girl_2019_OG.png`,
        },
        "DE-FY-01": {
            ogURL: "/marketplace/DE-FY-01",
            ogTitle: locale === "en" ? "Fancy Yellow Diamond 7,03 ct | Diamonds" : "Fancy Yellow Diamond 7,03 ct | Diamanten",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the second diamonds investment with a 7,03 ct Fancy Yellow Diamond. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit einem 7,03 ct Fancy Yellow Diamond das zweite Diamanten-Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Fancy_Yellow_Diamond_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Fancy_Yellow_Diamond_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Fancy_Yellow_Diamond_OG.png`,
        },
        "DE-FG-01": {
            ogURL: "/marketplace/DE-FG-01",
            ogTitle: locale === "en" ? "Fancy Green Diamond 1,03 ct | Diamonds" : "Fancy Green Diamond 1,03 ct | Diamanten",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the third diamonds investment with a 1,03 ct Fancy Green Diamond. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit einem 1,03 ct Fancy Green Diamond das dritte Diamanten-Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Fancy_Green_Diamond_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Fancy_Green_Diamond_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Fancy_Green_Diamond_OG.png`,
        },
        "DE-CF-01": {
            ogURL: "/marketplace/DE-CF-01",
            ogTitle: "Château Figeac Grand Cru Collection (2020) | Fine Wine",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine wine investment with the Château Figeac Grand Cru Collection (2020). Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit der Château Figeac Grand Cru Collection (2020) das nächste Fine Wine Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Chateau_Figeac_2020_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Chateau_Figeac_2020_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Chateau_Figeac_2020_OG.png`,
        },
        "DE-CC-01": {
            ogURL: "/marketplace/DE-CC-01",
            ogTitle: "Porsche 911 Turbo (1979) | Classic Cars Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the first classic cars investment with a Porsche 911 Turbo (1979). Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit einem Porsche 911 Turbo (1979) das erste Classic Cars Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Porsche_911_Turbo_1979_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Porsche_911_Turbo_1979_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Porsche_911_Turbo_1979_OG.png`,
        },
        "DE-PG-01": {
            ogURL: "/marketplace/DE-PG-01",
            ogTitle: "Penfolds Grange Vertical Collection | Fine Wine",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine wine investment with the Penfolds Grange Vertical Collection. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit der Penfolds Grange Vertical Collection das nächste Fine Wine Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Penfolds_Grange_Collection_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Penfolds_Grange_Collection_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Penfolds_Grange_Collection_OG.png`,
        },
        "DE-GU-02": {
            ogURL: "/marketplace/DE-GU-02",
            ogTitle:
                locale === "en"
                    ? "Günther Uecker – Both (2019) & Stream (2020) | Art Investment"
                    : "Günther Uecker – Both (2019) & Stream (2020) | Kunstinvestment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next art investment with the artworks Both (2019) & Stream (2020) by Günther Uecker. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit den Prägedruck-Kunstwerken Both (2019) & Stream (2020) von Günther Uecker das nächste Kunstinvestment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Guenther_Uecker_Both_2019_Stream_2020_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Guenther_Uecker_Both_2019_Stream_2020_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Guenther_Uecker_Both_2019_Stream_2020_OG.png`,
        },
        "DE-WE-01": {
            ogURL: "/marketplace/DE-WE-01",
            ogTitle: locale === "en" ? "Round Cut Diamond 3,02 ct | Diamonds" : "Round Cut Diamond 3,02 ct | Diamanten",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the fourth diamonds investment with a 3,02 ct Round Cut Diamond. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit einem 3,02 ct Round Cut Diamond das vierte Diamanten-Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Round_Cut_Diamond_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Round_Cut_Diamond_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Round_Cut_Diamond_OG.png`,
        },
        "DE-B-02": {
            ogURL: "/marketplace/DE-B-02",
            ogTitle:
                locale === "en"
                    ? "Prenzlauer Promenade! | Real Estate Investment"
                    : "Prenzlauer Promenade! | Immobilieninvestment",
            ogDescription:
                locale === "en"
                    ? "With Prenzlauer Promenade! Heinersdorf, FINEXITY launches the next real estate project in Berlin on the platform. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY bringt mit Prenzlauer Promenade! Heinerdorf das nächste Immobilienprojekt in Berlin auf die Plattform. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Prenzlauer_Promenade_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Prenzlauer_Promenade_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Prenzlauer_Promenade_OG.png`,
        },
        "DE-PH-01": {
            ogURL: "/marketplace/DE-PH-01",
            ogTitle: "Promontory Vintage Set | Fine Wine",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine wine investment with the Promontory Vintage Set. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit dem Promontory Vintage Set das nächste Fine Wine Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Promontory_Vintage_Set_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Promontory_Vintage_Set_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Promontory_Vintage_Set_OG.png`,
        },
        "DE-FB-01": {
            ogURL: "/marketplace/DE-FB-01",
            ogTitle: locale === "en" ? "Fancy Blue Diamond 1,36 ct | Diamonds" : "Fancy Blue Diamond 1,36 ct | Diamanten",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the fifth diamonds investment with a 1,36 ct Fancy Blue Diamond. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit einem 1,36 ct Fancy Blue Diamond das fünfte Diamanten-Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Fancy_Blue_Diamond_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Fancy_Blue_Diamond_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Fancy_Blue_Diamond_OG.png`,
        },
        "DE-HH-07": {
            ogURL: "/marketplace/DE-HH-07",
            ogTitle:
                locale === "en"
                    ? "Überseeallee! HafenCity | Real Estate Investment"
                    : "Überseeallee! HafenCity | Immobilieninvestment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY brings 'Überseeallee! HafenCity' the next real estate project in Hamburg on the platform. Investors can participate from 500 euros in the form of investment token."
                    : "FINEXITY bringt mit 'Überseeallee! HafenCity' das nächste Immobilienprojekt in Hamburg auf die Plattform. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Ueberseeallee_HafenCity_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Ueberseeallee_HafenCity_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Ueberseeallee_HafenCity_OG.png`,
        },
        "DE-JK-01": {
            ogURL: "/marketplace/DE-JK-01",
            ogTitle:
                locale === "en"
                    ? "Jeff Koons – Balloon Animals (2017 & 2019) | Art Investment"
                    : "Jeff Koons – Balloon Animals (2017 & 2019) | Kunstinvestment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next art investment with the sculpture series Balloon Animals (2017 & 2019) by Jeff Koons. Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY realisiert mit den Balloon Animals (2017 & 2019) von Jeff Koons das nächste Kunstinvestment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Jeff_Koons_Balloon_Animals_2017_2019_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Jeff_Koons_Balloon_Animals_2017_2019_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Jeff_Koons_Balloon_Animals_2017_2019_OG.png`,
        },
        "DE-BG-01": {
            ogURL: "/marketplace/DE-BG-01",
            ogTitle: "Bruno Giacosa Barolo Riserva | Fine Wine",
            ogDescription:
                locale === "en"
                    ? "FINEXITY launches the next Fine Wine Investment on the platform with the Bruno Giacosa Barolo Riserva. Investors can participate from 500 euros in the form of investment tokens."
                    : "FINEXITY bringt mit dem Bruno Giacosa Barolo Riserva ein neues Fine Wine Investment auf die Plattform. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Bruno_Giacosa_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Bruno_Giacosa_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Bruno_Giacosa_OG.png`,
        },
        "DE-FG-02": {
            ogURL: "/marketplace/DE-FG-02",
            ogTitle:
                locale === "en"
                    ? "1,54 ct Fancy Green Diamond | Diamond Investment"
                    : "1,54 ct Fancy Green Diamond | Diamanteninvestment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the sixth Diamond Investment with the 1,54 ct Fancy Green Diamond. Investors can participate in the form of investement tokens from 500 euros."
                    : "FINEXITY realisiert mit einem 1,54 ct Fancy Green Diamond das sechste Diamanten-Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_1-54_ct_Fancy_Green_Diamond_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_1-54_ct_Fancy_Green_Diamond_OG.png`,
            twitterImage: `/docs/social/FINEXITY_1-54_ct_Fancy_Green_Diamond_OG.png`,
        },
        "DE-AI-01": {
            ogURL: "/marketplace/DE-AI-01",
            ogTitle:
                locale === "en"
                    ? "Ai Weiwei - Study of Perspective in Glass (2018) | Art Investment"
                    : "Ai Weiwei - Study of Perspective in Glass (2018) | Kunstinvestment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises next art investment with the 'Study of Perspective in Glass (2018)' by Ai Weiwei. Investors can participate in the form of investement token from 500 euros."
                    : "FINEXITY realisiert mit 'Study of Perspective in Glass (2018)' von Ai Weiwei das nächste Kunstinvestment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Ai_Weiwei_Study_Perspective_Glass_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Ai_Weiwei_Study_Perspective_Glass_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Ai_Weiwei_Study_Perspective_Glass_OG.png`,
        },
        "DE-LR-01": {
            ogURL: "/marketplace/DE-LR-01",
            ogTitle: "Louis Roederer Cristal Rosé (2013) | Fine Wine Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine wine investment with the Louis Roederer Cristal Rosé (2013). Investors can participate in the form of investement token from 500 euros."
                    : "FINEXITY bringt mit dem Louis Roederer Cristal Rosé (2013) ein neues Fine Wine Investment auf die Plattform. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Louis_Roederer_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Louis_Roederer_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Louis_Roederer_OG.png`,
        },
        "DE-FRA-02": {
            ogURL: "/marketplace/DE-FRA-02",
            ogTitle:
                locale === "en"
                    ? "Ferdinand-Happ-Straße! Ostend | Real Estate Investment"
                    : "Ferdinand-Happ-Straße! Ostend | Immobilieninvestment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate investment in Frankfurt with Ferdinand-Happ-Straße! Ostend. Investors can participate in the form of investement token from 500 euros."
                    : "FINEXITY bringt mit Ferdinand-Happ-Straße! Ostend das nächste Immobilienprojekt in Frankfurt am Main auf die Plattform. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Ferdinand-Happ-Strasse_Ostend_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Ferdinand-Happ-Strasse_Ostend_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Ferdinand-Happ-Strasse_Ostend_OG.png`,
        },
        "DE-FB-02": {
            ogURL: "/marketplace/DE-FB-02",
            ogTitle:
                locale === "en"
                    ? "Fancy Blue Radiant Diamond 1.32 ct | Diamonds"
                    : "Fancy Blue Radiant Diamond 1,32 ct | Diamanten",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realizes the next diamond investment with a 1.32 ct Fancy Blue Radiant Diamond. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit einem 1,32 ct Fancy Blue Radiant Diamond das nächste Diamanten-Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Fancy_Blue_Radiant_Diamond_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Fancy_Blue_Radiant_Diamond_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Fancy_Blue_Radiant_Diamond_OG.png`,
        },
        "DE-GC-01": {
            ogURL: "/marketplace/DE-GC-01",
            ogTitle: "Giacomo Conterno Monfortino Riserva (2014) | Fine Wine Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine wine investment with the Giacomo Conterno Monfortino Riserva (2014). Investors can participate in the form of investement token from 500 euros."
                    : "FINEXITY bringt mit dem Giacomo Conterno Monfortino Riserva (2014) ein neues Fine Wine Investment auf die Plattform. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Giacomo_Conterno_Monfortino_Riserva_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Giacomo_Conterno_Monfortino_Riserva_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Giacomo_Conterno_Monfortino_Riserva_OG.png`,
        },
        "DE-AI-02": {
            ogURL: "/marketplace/DE-AI-02",
            ogTitle:
                locale === "en"
                    ? "Ai Weiwei - Study of Perspective in Glass (2020) | Art Investment"
                    : "Ai Weiwei - Study of Perspective in Glass (2020) | Kunstinvestment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises next art investment with the 'Study of Perspective in Glass (2020)' by Ai Weiwei. Investors can participate in the form of investement token from 500 euros."
                    : "FINEXITY realisiert mit 'Study of Perspective in Glass (2020)' von Ai Weiwei das nächste Kunstinvestment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Ai_Weiwei_Study_Perspective_Glass_2020_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Ai_Weiwei_Study_Perspective_Glass_2020_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Ai_Weiwei_Study_Perspective_Glass_2020_OG.png`,
        },
        "DE-CC-02": {
            ogURL: "/marketplace/DE-CC-02",
            ogTitle: "Ferrari 328 GTS (1989) | Classic Cars Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the second classic cars investment with a Ferrari 328 GTS (1989). Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit einem Ferrari 328 GTS (1989) das zweite Classic Cars Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Ferrari_328_GTS_1989_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Ferrari_328_GTS_1989_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Ferrari_328_GTS_1989_OG.png`,
        },
        "DE-TD-01": {
            ogURL: "/marketplace/DE-TD-01",
            ogTitle: locale === "en" ? "The Fancy Pear Trio | Diamonds" : "Das 'Fancy Pear Trio' | Diamanten",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realizes the next diamond investment with a Fancy Pear Trio of Diamonds. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit dem 'Fancy Pear Trio' das nächste Diamanten-Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_The_Fancy_Pear_Trio_Diamond_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_The_Fancy_Pear_Trio_Diamond_OG.png`,
            twitterImage: `/docs/social/FINEXITY_The_Fancy_Pear_Trio_Diamond_OG.png`,
        },
        "DE-JK-02": {
            ogURL: "/marketplace/DE-JK-02",
            ogTitle:
                locale === "en"
                    ? "Jeff Koons – Red Diamond (2020) Trio | Art Investment"
                    : "Jeff Koons – Red Diamond (2020) Trio | Kunstinvestment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next art investment with the Red Diamond (2020) Trio by Jeff Koons. Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY realisiert mit den Red Diamond (2020) Trio von Jeff Koons das nächste Kunstinvestment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Jeff_Koons_Red_Diamond_2020_Duo_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Jeff_Koons_Red_Diamond_2020_Duo_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Jeff_Koons_Red_Diamond_2020_Duo_OG.png`,
        },
        "CD-PP-DE-HH-03": {
            ogURL: "/marketplace/CD-PP-DE-HH-03",
            ogTitle: "Green Piece! Eimsbüttel - Club Deal | Real Estate Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate investment with the Green Piece! Eimsbüttel - Club Deal."
                    : "FINEXITY bringt mit dem Green Piece! Eimsbüttel - Club Deal das nächste Immobilienprojekt auf die Plattform.",
            ogImage: `/docs/social/FINEXITY_Green_Piece_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Green_Piece_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Green_Piece_CD_OG.png`,
        },
        "DE-HH-08": {
            ogURL: "/marketplace/DE-HH-08",
            ogTitle: "Glücksburger Platz! Eimsbüttel | Real Estate Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate investment with the Glücksburger Platz! Eimsbüttel. Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY bringt mit dem Glücksburger Platz! Eimsbüttel das nächste Immobilienprojekt auf die Plattform. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Glucksburger_Platz_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Glucksburger_Platz_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Glucksburger_Platz_OG.png`,
        },
        "DE-KA-01": {
            ogURL: "/marketplace/DE-KA-01",
            ogTitle: "KAWS: Good Intentions (2021) | Art Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next art investment with the sculpture Good Intentions (2021) by KAWS. Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY bringt mit dem Kunstwerk Good Intentions (2021) von KAWS das nächste Kunstinvestment auf die Plattform. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_KAWS_Good_Intentions_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_KAWS_Good_Intentions_OG.png`,
            twitterImage: `/docs/social/FINEXITY_KAWS_Good_Intentions_OG.png`,
        },
        "DE-FY-02": {
            ogURL: "/marketplace/DE-FY-02",
            ogTitle:
                locale === "en"
                    ? "11,54 ct Fancy Yellow Diamond | Diamond Investment"
                    : "11,54 ct Fancy Yellow Diamond | Diamanten-Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next Diamond Investment with the 11,54 ct Fancy Yellow Diamond. Investors can participate in the form of investement tokens from 500 euros."
                    : "FINEXITY realisiert mit einem 11,54 ct Fancy Yellow Diamond das sechste Diamanten-Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_11_ct_Fancy_Yellow_Diamond_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_11_ct_Fancy_Yellow_Diamond_OG.png`,
            twitterImage: `/docs/social/FINEXITY_11_ct_Fancy_Yellow_Diamond_OG.png`,
        },
        "DE-CC-03": {
            ogURL: "/marketplace/DE-CC-03",
            ogTitle: "Porsche 911 2.7 Carrera Targa (1975) | Classic Cars Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the third classic cars investment with a Porsche 911 2.7 Carrera Targa (1975). Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit einem Porsche 911 2.7 Carrera Targa (1975) das dritte Classic Cars Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Porsche_911_Carrera_Targa_1975_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Porsche_911_Carrera_Targa_1975_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Porsche_911_Carrera_Targa_1975_OG.png`,
        },
        "DE-PM-01": {
            ogURL: "/marketplace/DE-PM-01",
            ogTitle:
                locale === "en"
                    ? "Paul McCarthy PROPO 3 Skatedeck Sets with Flight Case (2016) | Art Investment"
                    : "Paul McCarthy PROPO 3 Skatedeck Sets mit Flight Case (2016) | Kunstinvestment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realizes the next art investment with PROPO 3 Skatedeck Sets with Flight Case (2016) by Paul McCarthy. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit den PROPO 3 Skatedeck Sets mit Flight Case (2016) von Paul McCarthy das nächste Kunstinvestment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Paul_McCarthy_Skatedeck_Sets_2016_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Paul_McCarthy_Skatedeck_Sets_2016_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Paul_McCarthy_Skatedeck_Sets_2016_OG.png`,
        },
        "DE-FP-02": {
            ogURL: "/marketplace/DE-FP-02",
            ogTitle:
                locale === "en"
                    ? "Fancy Pink Heart Diamond 1.01 ct | Diamond Investment"
                    : "Fancy Pink Heart Diamond 1,01 ct | Diamanteninvestment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realizes the next diamond investment with the Fancy Pink Heart Diamond with 1.01 ct. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit dem 1,01 ct Fancy Pink Heart Diamanten das nächste Diamanteninvestment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Fancy_Pink_Heart_Diamond_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Fancy_Pink_Heart_Diamond_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Fancy_Pink_Heart_Diamond_OG.png`,
        },
        "DE-RI-01": {
            ogURL: "/marketplace/DE-RI-01",
            ogTitle:
                locale === "en"
                    ? "Robert Indiana - Four Seasons of Hope Gold & Silver (2012) | Art Investment"
                    : "Robert Indiana - Four Seasons of Hope Gold & Silver (2012) | Kunstinvestment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realizes the next art investment with the Four Seasons of Hope Gold & Silver (2012) by Robert Indiana. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit den Kunstmappen Four Seasons of Hope Gold & Silver (2012) von Robert Indiana das nächste Kunstinvestment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Robert_Indiana_Hope_Gold_Silver_2012_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Robert_Indiana_Hope_Gold_Silver_2012_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Robert_Indiana_Hope_Gold_Silver_2012_OG.png`,
        },
        "DE-HH-09": {
            ogURL: "/marketplace/DE-HH-09",
            ogTitle:
                locale === "en"
                    ? "Börnestraße 2.0 - Eilbek | Real Estate Investment"
                    : "Börnestraße 2.0 - Eilbek | Immobilieninvestment",
            ogDescription:
                locale === "en"
                    ? "With Börnestraße 2.0 - Eilbek, FINEXITY launches the next real estate project in Hamburg on the platform. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY bringt mit Börnestraße 2.0 - Eilbek das nächste Immobilienprojekt in Hamburg auf die Plattform. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Boernestrasse_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Boernestrasse_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Boernestrasse_OG.png`,
        },
        "DE-CM-01": {
            ogURL: "/marketplace/DE-CM-01",
            ogTitle: "Château Mouton Rothschild (2016) | Fine Wine Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine wine investment with the Château Mouton Rothschild (2016). Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY bringt mit dem Château Mouton Rothschild (2016) ein neues Fine Wine Investment auf die Plattform. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Chateau_Mouton_Rothschild_2016_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Chateau_Mouton_Rothschild_2016_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Chateau_Mouton_Rothschild_2016_OG.png`,
        },
        "DE-FG-03": {
            ogURL: "/marketplace/DE-FG-03",
            ogTitle:
                locale === "en"
                    ? "Fancy Green Oval 1.01 ct Diamond | Diamond Investment"
                    : "Fancy Green Oval 1,01 ct Diamant | Diamanteninvestment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realizes the next diamond investment with the Fancy Green Oval 1.01 ct diamond. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit dem Fancy Green Oval 1,01 ct Diamanten das nächste Diamanteninvestment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Fancy_Green_Oval_Diamond_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Fancy_Green_Oval_Diamond_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Fancy_Green_Oval_Diamond_OG.png`,
        },
        "DE-CC-04": {
            ogURL: "/marketplace/DE-CC-04",
            ogTitle: "BMW E30 M3 (1987) | Classic Cars Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next classic cars investment with a BMW E30 M3 (1987). Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit einem BMW E30 M3 (1987) das nächste Classic Cars Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_BMW_E30_M3_1987_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_BMW_E30_M3_1987_OG.png`,
            twitterImage: `/docs/social/FINEXITY_BMW_E30_M3_1987_OG.png`,
        },
        "DE-FP-03": {
            ogURL: "/marketplace/DE-FP-03",
            ogTitle:
                locale === "en"
                    ? "Fancy Pink Diamond 1.69 ct Diamond | Diamond Investment"
                    : "Fancy Pink Diamond 1,69 ct Diamant | Diamanteninvestment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next diamond investment with a Fancy Pink Diamond 1.69 ct. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit einem Fancy Pink Diamond 1,69 ct das nächste Diamanten Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Fancy_Pink_Diamond_1-69_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Fancy_Pink_Diamond_1-69_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Fancy_Pink_Diamond_1-69_OG.png`,
        },
        "DE-KA-02": {
            ogURL: "/marketplace/DE-KA-02",
            ogTitle: "KAWS: The News (2018) | Art Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next art investment with The News (2018) by KAWS. Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY bringt mit dem Kunstwerk The News (2018) von KAWS das nächste Kunstinvestment auf die Plattform. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_KAWS_TheNews_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_KAWS_TheNews_OG.png`,
            twitterImage: `/docs/social/FINEXITY_KAWS_TheNews_OG.png`,
        },
        "DE-PP-01": {
            ogURL: "/marketplace/DE-PP-01",
            ogTitle: "Pétrus Double Magnum (2015) | Fine Wine Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine wine investment with the Pétrus (2015). Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY bringt mit dem Pétrus (2015) ein neues Fine Wine Investment auf die Plattform. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Petrus_Pomorol_2015_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Petrus_Pomorol_2015_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Petrus_Pomorol_2015_OG.png`,
        },
        "DE-K-02": {
            ogURL: "/marketplace/DE-K-02",
            ogTitle:
                locale === "en"
                    ? "Gutenberg! Ehrenfeld in Cologne | Real Estate Investment"
                    : "Gutenberg! Ehrenfeld in Köln | Immobilieninvestment",
            ogDescription:
                locale === "en"
                    ? "With Gutenberg! Ehrenfeld, FINEXITY launches the next real estate project in Cologne on the platform. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY bringt mit Gutenberg! Ehrenfeld das nächste Immobilienprojekt in Köln auf die Plattform. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Gutenberg_Ehrenfeld_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Gutenberg_Ehrenfeld_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Gutenberg_Ehrenfeld_OG.png`,
        },
        "DE-FO-01": {
            ogURL: "/marketplace/DE-FO-01",
            ogTitle:
                locale === "en"
                    ? "Fancy Vivid Orange 1,01 ct Diamond | Diamond Investment"
                    : "Fancy Vivid Orange 1,01 ct Diamant | Diamanteninvestment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next diamond investment with a Fancy Vivid Orange 1,01 ct Diamond. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit einem Fancy Vivid Orange Diamanten mit 1,01 ct das nächste Diamanten Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Fancy_Vivid_Orange_Oval_Diamond_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Fancy_Vivid_Orange_Oval_Diamond_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Fancy_Vivid_Orange_Oval_Diamond_OG.png`,
        },
        "DE-CC-05": {
            ogURL: "/marketplace/DE-CC-05",
            ogTitle: "Alfa Romeo Giulia GT Veloce 1600 (1966) | Classic Cars Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next classic cars investment with a Alfa Romeo Giulia GT Veloce 1600 (1966). Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit einem Alfa Romeo Giulia GT Veloce 1600 (1966) das nächste Classic Cars Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Alfa_Romeo_Giulia_GTV_1966_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Alfa_Romeo_Giulia_GTV_1966_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Alfa_Romeo_Giulia_GTV_1966_OG.png`,
        },
        "SACHWERT-01": {
            ogURL: "/marketplace/SACHWERT-01",
            ogTitle: "Kindergarten & Wohnen in Woltmershausen | Immobilieninvestment",
            ogDescription:
                "Das Immobilienprojekt in Woltmershausen verbindet Kindergarten & Wohnen. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/sachwertinvest/Sachwert_Invest_Kindergarten_Wohnen_Woltmershausen_OG.png`,
            ogImageURL: `/docs/social/sachwertinvest/Sachwert_Invest_Kindergarten_Wohnen_Woltmershausen_OG.png`,
            twitterImage: `/docs/social/sachwertinvest/Sachwert_Invest_Kindergarten_Wohnen_Woltmershausen_OG.png`,
        },
        "SACHWERT-02": {
            ogURL: "/marketplace/SACHWERT-02",
            ogTitle: "Remberti! Sozial Engagiert | Immobilieninvestment",
        },
        "SACHWERT-03": {
            ogURL: "/marketplace/SACHWERT-03",
            ogTitle: "Remberti! Inst. Sozial Engagiert | Immobilieninvestment",
        },
        "SACHWERT-04": {
            ogURL: "/marketplace/SACHWERT-04",
            ogTitle: "Solarpark Zemitz | Renewables",
        },
        "SACHWERT-05": {
            ogURL: "/marketplace/SACHWERT-05",
            ogTitle: "Kindertagesstätte Wendeburg | Immobilieninvestment",
        },
        "SACHWERT-06": {
            ogURL: "/marketplace/SACHWERT-06",
            ogTitle: "Deutsche Premium Weine 1 | Wein-Investment",
        },
        "ASSETTA-01": {
            ogURL: "/marketplace/ASSETTA-01",
            ogTitle:
                locale === "en"
                    ? "Blanes One - Mallorca - Costa d'en Blanes, Calvia, Illes Balears, Spain"
                    : "Blanes One - Mallorca - Costa d'en Blanes, Calvia, Illes Balears, Spanien | Immobilieninvestment",
            ogDescription:
                locale === "en"
                    ? "Real estate investment project Blanes One - Mallorca - Costa d'en Blanes, Calvia, Illes Balears, Spain. Investors can participate in the form of investment tokens from 500 euros."
                    : "Ferienimmobilie Projekt Blanes One - Mallorca - Costa d'en Blanes, Calvia, Illes Balears, Spanien. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/assetta/ASSETA_Blanes_One_OG.png`,
            ogImageURL: `/docs/social/assetta/ASSETA_Blanes_One_OG.png`,
            twitterImage: `/docs/social/assetta/ASSETA_Blanes_One_OG.png`,
        },
        "DE-PR-01": {
            ogURL: "/marketplace/DE-PR-01",
            ogTitle: "Laurent-Perrier Alexandra Rosé (2004) | Fine Wine Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine wine investment with the Laurent-Perrier Alexandra Rosé (2004). Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY bringt mit dem Laurent-Perrier Alexandra Rosé (2004) ein neues Fine Wine Investment auf die Plattform. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Laurent_Perrier_Alexandra_Rose_2004_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Laurent_Perrier_Alexandra_Rose_2004_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Laurent_Perrier_Alexandra_Rose_2004_OG.png`,
        },
        "DE-AP-01": {
            ogURL: "/marketplace/DE-AP-01",
            ogTitle: "A. R. Penck - Untitled (Drei von Vielen, 1990) | Art Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next art investment with Untitled (Drei von Vielen, 1990) by A. R. Penck. Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY bringt mit dem Kunstwerk Untitled (Drei von Vielen, 1990) von A. R. Penck das nächste Kunstinvestment auf die Plattform. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Penck_Untitled_Drei_Von_Vielen_1990_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Penck_Untitled_Drei_Von_Vielen_1990_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Penck_Untitled_Drei_Von_Vielen_1990_OG.png`,
        },
        "DE-FP-04": {
            ogURL: "/marketplace/DE-FP-04",
            ogTitle:
                locale === "en"
                    ? "Fancy Intense Pink 0,40 ct Diamond | Diamond Investment"
                    : "Fancy Intense Pink 0,40 ct Diamant | Diamanteninvestment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next diamond investment with a Fancy Intense Pink 0,40 ct Diamond. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit einem Fancy Intense Pink mit 0,40 ct das nächste Diamanteninvestment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Fancy_Intense_Pink_0-40_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Fancy_Intense_Pink_0-40_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Fancy_Intense_Pink_0-40_OG.png`,
        },
        "DE-RC-02": {
            ogURL: "/marketplace/DE-RC-02",
            ogTitle: "Domaine de la Romanée-Conti (2012) | Fine Wine Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine wine investment with the Domaine de la Romanée-Conti (2012)."
                    : "FINEXITY realisiert mit dem Domaine de la Romanée-Conti (2012) das nächste Fine Wine Investment.",
            ogImage: `/docs/social/FINEXITY_DRC_2012_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_DRC_2012_OG.png`,
            twitterImage: `/docs/social/FINEXITY_DRC_2012_OG.png`,
        },
        "DE-DH-01": {
            ogURL: "/marketplace/DE-DH-01",
            ogTitle: "Damien Hirst - The Cure (2014) | Art Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next art investment with The Cure (2014) by Damien Hirst. Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY bringt mit dem Kunstwerk The Cure (2014) von Damien Hirst das nächste Kunstinvestment auf die Plattform. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Damien_Hirst_The_Cure_2014_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Damien_Hirst_The_Cure_2014_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Damien_Hirst_The_Cure_2014_OG.png`,
        },
        "DE-FG-04": {
            ogURL: "/marketplace/DE-FG-04",
            ogTitle:
                locale === "en"
                    ? "Fancy Intense Green 1,55 ct Diamond | Diamond Investment"
                    : "Fancy Intense Green 1,55 ct Diamant | Diamanteninvestment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next diamond investment with a Fancy Intense Green 1,55 ct Diamond. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit einem Fancy Intense Green 1,55 ct das nächste Diamanteninvestment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Fancy_Intense_Green_1-55_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Fancy_Intense_Green_1-55_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Fancy_Intense_Green_1-55_OG.png`,
        },
        "DE-CC-06": {
            ogURL: "/marketplace/DE-CC-06",
            ogTitle: "Porsche 964 Speedster (1993) | Classic Cars Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next classic cars investment with a Porsche 964 Speedster (1993). Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit einem Porsche 964 Speedster (1993) das nächste Classic Cars Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Porsche_964_Speedster_1993_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Porsche_964_Speedster_1993_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Porsche_964_Speedster_1993_OG.png`,
        },
        "DE-BK-01": {
            ogURL: "/marketplace/DE-BK-01",
            ogTitle: "Boërl & Kroff Vertical Collection | Fine Wine Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine wine investment with a Boërl & Kroff Vertical Collection."
                    : "FINEXITY realisiert mit der Boërl & Kroff Vertical Collection das nächste Fine Wine Investment.",
            ogImage: `/docs/social/FINEXITY_Boerl_Kroff_Vertical_Collection_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Boerl_Kroff_Vertical_Collection_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Boerl_Kroff_Vertical_Collection_OG.png`,
        },
        "DE-FP-05": {
            ogURL: "/marketplace/DE-FP-05",
            ogTitle: "Fancy Pink Duo | Diamanteninvestment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next diamond investment with Fancy Pink Duo Diamonds. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit dem Fancy Pink Duo das nächste Diamanteninvestment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Fancy_Pink_Duo_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Fancy_Pink_Duo_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Fancy_Pink_Duo_OG.png`,
        },
        "DE-ST-01": {
            ogURL: "/marketplace/DE-ST-01",
            ogTitle: "Sassicaia (2018) | Fine Wine Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine wine investment with a Sassicaia (2018)."
                    : "FINEXITY realisiert mit einem Sassicaia (2018) das nächste Fine Wine Investment.",
            ogImage: `/docs/social/FINEXITY_Sassicaia_2018_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Sassicaia_2018_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Sassicaia_2018_OG.png`,
        },
        "DE-S-01": {
            ogURL: "/marketplace/DE-S-01",
            ogTitle: "Rotbuche! Calw | Real Estate Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate investment with the Rotbuche! Calw. Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY bringt mit Rotbuche! Calw das nächste Immobilienprojekt auf die Plattform. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Rotbuche_Calw_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Rotbuche_Calw_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Rotbuche_Calw_OG.png`,
        },
        "CD-PP-DE-S-01": {
            ogURL: "/marketplace/CD-PP-DE-S-01",
            ogTitle: "Eschenweg! Calw - Club Deal | Real Estate Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate investment with the Eschenweg! Calw - Club Deal."
                    : "FINEXITY bringt mit dem Eschenweg! Calw - Club Deal das nächste Immobilienprojekt auf die Plattform.",
            ogImage: `/docs/social/FINEXITY_Eschenweg_Calw_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Eschenweg_Calw_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Eschenweg_Calw_CD_OG.png`,
        },
        "DE-AW-04": {
            ogURL: "/marketplace/DE-AW-04",
            ogTitle:
                locale === "en"
                    ? "Andy Warhol - Joseph Beuys in Memoriam (1986) | Art Investment"
                    : "Andy Warhol – Joseph Beuys in Memoriam (1986) | Kunstinvestment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY expands its art collection with the art work Joseph Beuys in Memoriam (1986) by Andy Warhol. Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY erweitert mit dem Kunstwerk Joseph Beuys in Memoriam (1986) von Andy Warhol ihre Kunstsammlung. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Andy_Warhol_Joseph_Beuys_In_Memoriam_1986_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Andy_Warhol_Joseph_Beuys_In_Memoriam_1986_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Andy_Warhol_Joseph_Beuys_In_Memoriam_1986_OG.png`,
        },
        "DE-AE-01": {
            ogURL: "/marketplace/DE-AE-01",
            ogTitle: "Arnaud Ente Collection (2018) | Fine Wine Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine wine investment with a Arnaud Ente Collection (2018). Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY realisiert mit einer Arnaud Ente Collection (2018) das nächste Fine Wine Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Arnaud_Ente_Collection_2018_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Arnaud_Ente_Collection_2018_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Arnaud_Ente_Collection_2018_OG.png`,
        },
        "DE-BA-01": {
            ogURL: "/marketplace/DE-BA-01",
            ogTitle: "Banksy - Applause (2006) | Art Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine art investment with Applause (2006) by Banksy. Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY realisiert mit dem Kunstwerk Applause (2006) von Banksy das nächste Kunst Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Banksy_Applause_2006_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Banksy_Applause_2006_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Banksy_Applause_2006_OG.png`,
        },
        "WATCHVEST-01": {
            ogURL: "/marketplace/WATCHVEST-01",
            ogTitle: "Rolex GMT II - Batman & Batgirl | Watches Investment",
            ogDescription:
                locale === "en"
                    ? "Watches investment product Rolex GMT II - Batman & Batgirl. Investors can participate in the form of investment token from 500 euros."
                    : "Luxusuhren Investment Rolex GMT II - Batman & Batgirl. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/watchvest/WATCHVEST_Rolex_GTM_II_BB_OG.png`,
            ogImageURL: `/docs/social/watchvest/WATCHVEST_Rolex_GTM_II_BB_OG.png`,
            twitterImage: `/docs/social/watchvest/WATCHVEST_Rolex_GTM_II_BB_OG.png`,
        },
        "DE-WD-01": {
            ogURL: "/marketplace/DE-WD-01",
            ogTitle: "Emerald Cut 6,01 ct | Diamanteninvestment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next diamond investment with Emerald Cut 6,01 ct Diamond. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit dem Emerald Cut 6,01 ct das nächste Diamanteninvestment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Emerald_Cut_6-01_ct_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Emerald_Cut_6-01_ct_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Emerald_Cut_6-01_ct_OG.png`,
        },
        "DE-RL-01": {
            ogURL: "/marketplace/DE-RL-01",
            ogTitle: "Roy Lichtenstein - Six Still Lifes (1974) (3 Drucke) | Art Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine art investment with Six Still Lifes (1974) (3 Prints) by Roy Lichtenstein. Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY realisiert mit dem Kunstwerk Six Still Lifes (1974) (3 Drucke) von Roy Lichtenstein das nächste Kunst Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Roy_Lichtenstein_Six_Still_Lifes_1974_3-6_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Roy_Lichtenstein_Six_Still_Lifes_1974_3-6_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Roy_Lichtenstein_Six_Still_Lifes_1974_3-6_OG.png`,
        },
        "DE-CC-07": {
            ogURL: "/marketplace/DE-CC-07",
            ogTitle: "Jaguar E-Type Series 1 (1962) | Classic Cars Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next classic cars investment with a Jaguar E-Type Series 1 (1962). Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit einem Jaguar E-Type Series 1 (1962) das nächste Classic Cars Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Jaguar_E-Type_Series_1_1962_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Jaguar_E-Type_Series_1_1962_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Jaguar_E-Type_Series_1_1962_OG.png`,
        },
        "DE-CC-08": {
            ogURL: "/marketplace/DE-CC-08",
            ogTitle: "Ferrari Dino 208 GT4 | Classic Cars Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next classic cars investment with a Ferrari Dino 208 GT4. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit einem Ferrari Dino 208 GT4 das nächste Classic Cars Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Ferrari_Dino_208_GT4_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Ferrari_Dino_208_GT4_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Ferrari_Dino_208_GT4_OG.png`,
        },
        "DE-CC-09": {
            ogURL: "/marketplace/DE-CC-09",
            ogTitle: "Ferrari 308 GTB QV | Classic Cars Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next classic cars investment with a Ferrari 308 GTB QV. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit einem Ferrari 308 GTB QV das nächste Classic Cars Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Ferrari_308_GTB_QV_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Ferrari_308_GTB_QV_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Ferrari_308_GTB_QV_OG.png`,
        },
        "DE-CC-10": {
            ogURL: "/marketplace/DE-CC-10",
            ogTitle: "Mercedes 190 E Evo 1 | Classic Cars Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next classic cars investment with a Mercedes 190 E Evo 1. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit einem Mercedes 190 E Evo 1 das nächste Classic Cars Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Mercedes_190_E_EVO_1_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Mercedes_190_E_EVO_1_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Mercedes_190_E_EVO_1_OG.png`,
        },
        "DE-CL-02": {
            ogURL: "/marketplace/DE-CL-02",
            ogTitle: "Château Lafite Rothschild (2021) | Fine Wine Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine wine investment with a Château Lafite Rothschild (2021). Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY realisiert mit dem Château Lafite Rothschild (2021) das nächste Fine Wine Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Chateau_Lafite_Rothschild_2021_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Chateau_Lafite_Rothschild_2021_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Chateau_Lafite_Rothschild_2021_OG.png`,
        },
        "DE-PD-01": {
            ogURL: "/marketplace/DE-PD-01",
            ogTitle: "Peter Doig - Zermatt (2022) | Art Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine art investment with Zermatt (2022) by Peter Doig. Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY realisiert mit dem Kunstwerk Zermatt (2022) von Peter Doig das nächste Kunst Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Peter_Doig_Zermatt_2022_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Peter_Doig_Zermatt_2022_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Peter_Doig_Zermatt_2022_OG.png`,
        },
        "WIN-01": {
            ogURL: "/marketplace/WIN-01",
            ogTitle: "Bramfelder Chaussee | Real Estate Investment",
        },
        "WIN-02": {
            ogURL: "/marketplace/WIN-02",
            ogTitle: "Seekamp Bramfeld | Real Estate Investment",
        },
        "WIN-03": {
            ogURL: "/marketplace/WIN-03",
            ogTitle: "Park Living Obermenzing | Real Estate Investment",
        },
        "WIN-04": {
            ogURL: "/marketplace/WIN-04",
            ogTitle: "Green Tiny House Jan | Real Estate Investment",
        },
        "WIN-05": {
            ogURL: "/marketplace/WIN-05",
            ogTitle: "Green Tiny House Tim | Real Estate Investment",
        },
        "WIN-06": {
            ogURL: "/marketplace/WIN-06",
            ogTitle: "Green Tiny House Daniela | Real Estate Investment",
        },
        "WIN-07": {
            ogURL: "/marketplace/WIN-07",
            ogTitle: "Green Tiny House Marcus | Real Estate Investment",
        },
        "WIN-08": {
            ogURL: "/marketplace/WIN-08",
            ogTitle: "Green Tiny House Oscar | Real Estate Investment",
        },
        "DE-FO-02": {
            ogURL: "/marketplace/DE-FO-02",
            ogTitle:
                locale === "en"
                    ? "Fancy Vivid Orange 1,03 ct Diamond | Diamond Investment"
                    : "Fancy Vivid Orange 1,03 ct Diamant | Diamanteninvestment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next diamond investment with a Fancy Vivid Orange 1,03 ct Diamond. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit einem Fancy Vivid Orange Diamanten mit 1,03 ct das nächste Diamanten Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Fancy_Vivid_Orange_1-03_Diamond_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Fancy_Vivid_Orange_1-03_Diamond_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Fancy_Vivid_Orange_1-03_Diamond_OG.png`,
        },
        "DE-DP-01": {
            ogURL: "/marketplace/DE-DP-01",
            ogTitle: "Dom Pérignon Brut & Rosé Collection (2008 & 2012) | Fine Wine Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine wine investment with a Dom Pérignon Brut & Rosé Collection (2008 & 2012). Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY realisiert mit der Dom Pérignon Brut & Rosé Collection (2008 & 2012) das nächste Fine Wine Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Dom_Perignon_Brut_Rose_Collection_2008_2012_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Dom_Perignon_Brut_Rose_Collection_2008_2012_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Dom_Perignon_Brut_Rose_Collection_2008_2012_OG.png`,
        },
        "WATCHVEST-02": {
            ogURL: "/marketplace/WATCHVEST-02",
            ogTitle: "Rolex Daytona Cosmograph Stahl | Watches Investment",
            ogDescription:
                locale === "en"
                    ? "Watches investment product Rolex Daytona Cosmograph Stahl. Investors can participate in the form of investment token from 500 euros."
                    : "Luxusuhren Investment Rolex Daytona Cosmograph Stahl. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/watchvest/WATCHVEST_Rolex_Daytona_Cosmograph_Stahl_OG.png`,
            ogImageURL: `/docs/social/watchvest/WATCHVEST_Rolex_Daytona_Cosmograph_Stahl_OG.png`,
            twitterImage: `/docs/social/watchvest/WATCHVEST_Rolex_Daytona_Cosmograph_Stahl_OG.png`,
        },
        "WATCHVEST-03": {
            ogURL: "/marketplace/WATCHVEST-03",
            ogTitle: "Rolex GMT Master II 'Pepsi' | Watches Investment",
            ogDescription:
                locale === "en"
                    ? "Watches investment product Rolex GMT Master II 'Pepsi'. Investors can participate in the form of investment token from 500 euros."
                    : "Luxusuhren Investment Rolex GMT Master II 'Pepsi'. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/watchvest/WATCHVEST_Rolex_GMT_Master_II_Pepsi_OG.png`,
            ogImageURL: `/docs/social/watchvest/WATCHVEST_Rolex_GMT_Master_II_Pepsi_OG.png`,
            twitterImage: `/docs/social/watchvest/WATCHVEST_Rolex_GMT_Master_II_Pepsi_OG.png`,
        },
        "DE-FRA-03": {
            ogURL: "/marketplace/DE-FRA-03",
            ogTitle: "Zeil Omega! Konstablerwache | Real Estate Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate investment with the Zeil Omega! Konstablerwache. Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY bringt mit Zeil Omega! Konstablerwache das nächste Immobilienprojekt auf die Plattform. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Zeil_Omega_Konstablerwache_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Zeil_Omega_Konstablerwache_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Zeil_Omega_Konstablerwache_OG.png`,
        },
        "CD-PP-DE-FRA-01": {
            ogURL: "/marketplace/CD-PP-DE-FRA-01",
            ogTitle: "Zeil 44! Konstablerwache - Club Deal | Real Estate Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate investment with the Zeil 44! Konstablerwache - Club Deal."
                    : "FINEXITY bringt mit dem Zeil 44! Konstablerwache - Club Deal das nächste Immobilienprojekt auf die Plattform.",
            ogImage: `/docs/social/FINEXITY_Zeil_44_Konstablerwache_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Zeil_44_Konstablerwache_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Zeil_44_Konstablerwache_CD_OG.png`,
        },
        "DE-SE-01": {
            ogURL: "/marketplace/DE-SE-01",
            ogTitle: "Screaming Eagle Vertical Collection | Fine Wine Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine wine investment with a Screaming Eagle Vertical Collection. Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY realisiert mit einer Screaming Eagle Vertical Collection das nächste Fine Wine Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Screaming_Eagle_Vertical_Collection_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Screaming_Eagle_Vertical_Collection_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Screaming_Eagle_Vertical_Collection_OG.png`,
        },
        "DE-FP-06": {
            ogURL: "/marketplace/DE-FP-06",
            ogTitle:
                locale === "en"
                    ? "Fancy Intense Pink 1,07 ct Diamond | Diamond Investment"
                    : "Fancy Intense Pink 1,07 ct Diamant | Diamanteninvestment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next diamond investment with a Fancy Intense Pink 1,07 ct Diamond. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit einem Fancy Intense Pink Diamanten mit 1,07 ct das nächste Diamanten Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Fancy_Intense_Pink_1-07_Diamond_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Fancy_Intense_Pink_1-07_Diamond_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Fancy_Intense_Pink_1-07_Diamond_OG.png`,
        },
        "WA-PP-01": {
            ogURL: "/marketplace/WA-PP-01",
            ogTitle: "Patek Philippe Aquanaut Stahl | Watches Investment",
            ogDescription:
                locale === "en"
                    ? "Watches investment product Patek Philippe Aquanaut Stahl. Investors can participate in the form of investment token from 500 euros."
                    : "Luxusuhren Investment Patek Philippe Aquanaut Stahl. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Patek_Philippe_Aquanaut_Stahl_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Patek_Philippe_Aquanaut_Stahl_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Patek_Philippe_Aquanaut_Stahl_OG.png`,
        },
        "DI-FP-01": {
            ogURL: "/marketplace/DI-FP-01",
            ogTitle:
                locale === "en"
                    ? "Fancy Purple Duo 0.50 ct Diamond | Diamond Investment"
                    : "Fancy Purple Duo 0,50 ct Diamant | Diamanten Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next diamond investment with a Fancy Purple Duo each 0.50 ct Diamond. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit einem Fancy Purple Duo mit je 0,50 ct das nächste Diamanten Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Fancy_Purple_Duo_0-50_Diamond_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Fancy_Purple_Duo_0-50_Diamond_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Fancy_Purple_Duo_0-50_Diamond_OG.png`,
        },
        "FA-BA-01": {
            ogURL: "/marketplace/FA-BA-01",
            ogTitle: "Banksy - Sale Ends V.2 (2017) | Fine Art Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine art investment with Sale Ends V.2 (2017) by Banksy. Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY realisiert mit dem Kunstwerk Sale Ends V.2 (2017) von Banksy das nächste Kunst Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Banksy_Sale_Ends_v2_2017_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Banksy_Sale_Ends_v2_2017_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Banksy_Sale_Ends_v2_2017_OG.png`,
        },
        "FA-JS-01": {
            ogURL: "/marketplace/FA-JS-01",
            ogTitle: "Josh Sperling - Untitled Composite (2020) | Fine Art Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine art investment with Untitled Composite (2020) by Josh Sperling. Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY realisiert mit dem Kunstwerk Untitled Composite (2020) von Josh Sperling das nächste Kunst Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Josh_Sperling_Untitled_Composite_2020_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Josh_Sperling_Untitled_Composite_2020_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Josh_Sperling_Untitled_Composite_2020_OG.png`,
        },
        "PE-CV-01": {
            ogURL: "/marketplace/PE-CV-01",
            ogTitle: "Cavarly Ventures III | Private Equity Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next private equity investment with Cavarly Ventures III. Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY realisiert mit dem Cavarly Ventures III nächste Private Equity Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_PE_Cavarly_Ventures_III_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_PE_Cavarly_Ventures_III_OG.png`,
            twitterImage: `/docs/social/FINEXITY_PE_Cavarly_Ventures_III_OG.png`,
        },
        "PE-LB-01": {
            ogURL: "/marketplace/PE-LB-01",
            ogTitle: "DRS Software Opportunity Fund | Private Equity Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next private equity investment with DRS Software Opportunity Fund. Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY realisiert mit dem DRS Software Opportunity Fund nächste Private Equity Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_PE_DRS_Software_Opportunity_Fund_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_PE_DRS_Software_Opportunity_Fund_OG.png`,
            twitterImage: `/docs/social/FINEXITY_PE_DRS_Software_Opportunity_Fund_OG.png`,
        },
        "CD-PP-PE-LB-01": {
            ogURL: "/marketplace/CD-PP-PE-LB-01",
            ogTitle: "DRS Software Opportunity Fund Junior | Private Equity Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next private equity investment with DRS Software Opportunity Fund Junior."
                    : "FINEXITY realisiert mit dem DRS Software Opportunity Fund Junior nächste Private Equity Investment.",
            ogImage: `/docs/social/FINEXITY_PE_DRS_Software_Opportunity_Fund_Junior_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_PE_DRS_Software_Opportunity_Fund_Junior_OG.png`,
            twitterImage: `/docs/social/FINEXITY_PE_DRS_Software_Opportunity_Fund_Junior_OG.png`,
        },
        "CD-PP-PE-LB-02": {
            ogURL: "/marketplace/CD-PP-PE-LB-02",
            ogTitle: "DRS Software Opportunity Fund Senior | Private Equity Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next private equity investment with DRS Software Opportunity Fund Senior."
                    : "FINEXITY realisiert mit dem DRS Software Opportunity Fund Senior das nächste Private Equity Investment.",
            ogImage: `/docs/social/FINEXITY_PE_DRS_Software_Opportunity_Fund_Senior_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_PE_DRS_Software_Opportunity_Fund_Senior_OG.png`,
            twitterImage: `/docs/social/FINEXITY_PE_DRS_Software_Opportunity_Fund_Senior_OG.png`,
        },
        "WA-RX-01": {
            ogURL: "/marketplace/WA-RX-01",
            ogTitle: "Rolex Daytona - Gold Collection (2021) | Watches Investment",
            ogDescription:
                locale === "en"
                    ? "Watches investment product Rolex Daytona - Gold Collection (2021). Investors can participate in the form of investment token from 500 euros."
                    : "Luxusuhren Investment Rolex Daytona - Gold Collection (2021). Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Rolex_Daytona_Gold_Collection_2021_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Rolex_Daytona_Gold_Collection_2021_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Rolex_Daytona_Gold_Collection_2021_OG.png`,
        },
        "FA-EH-01": {
            ogURL: "/marketplace/FA-EH-01",
            ogTitle: "Eva Hassmann - 06.03pm, 12.03pm, 05.50pm (2014) | Fine Art Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine art investment with 06.03pm, 12.03pm, 05.50pm (2014) by Eva Hassmann. Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY realisiert mit dem Kunstwerk 06.03pm, 12.03pm, 05.50pm (2014) von Eva Hassmann das nächste Kunst Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Eva_Hassmann_06-03pm_12-03pm_05-50pm_2014_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Eva_Hassmann_06-03pm_12-03pm_05-50pm_2014_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Eva_Hassmann_06-03pm_12-03pm_05-50pm_2014_OG.png`,
        },
        "FW-BS-01": {
            ogURL: "/marketplace/FW-BS-01",
            ogTitle: "Biondi-Santi Riserva (2015) | Fine Wine Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine wine investment with a Biondi-Santi Riserva (2015). Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY realisiert mit einer Biondi-Santi Riserva (2015) das nächste Fine Wine Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Biondi_Santi_Riserva_2015_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Biondi_Santi_Riserva_2015_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Biondi_Santi_Riserva_2015_OG.png`,
        },
        "FA-GU-01": {
            ogURL: "/marketplace/FA-GU-01",
            ogTitle: "Günther Uecker - Poesie der Destruktion (1994) | Fine Art Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine art investment with Günther Uecker's artwork 'Poesie der Destruktion (1994)'. Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY realisiert mit dem Kunstwerk Poesie der Destruktion (1994) von Günther Uecker das nächste Kunst Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Gunther_Uecker_Poesie_der_Destruktion_1994_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Gunther_Uecker_Poesie_der_Destruktion_1994_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Gunther_Uecker_Poesie_der_Destruktion_1994_OG.png`,
        },
        "DI-FY-01": {
            ogURL: "/marketplace/DI-FY-01",
            ogTitle:
                locale === "en"
                    ? "Fancy Vivid Yellow 2.51 ct Diamond | Diamond Investment"
                    : "Fancy Vivid Yellow 2,51 ct Diamant | Diamanten Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next diamond investment with a Fancy Vivid Yellow 2.51 ct Diamond. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit einem Fancy Vivid Yellow 2,51 ct das nächste Diamanten Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Fancy_Vivid_Yellow_2-51_Diamond_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Fancy_Vivid_Yellow_2-51_Diamond_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Fancy_Vivid_Yellow_2-51_Diamond_OG.png`,
        },
        "CD-PP-DE-MA-01": {
            ogURL: "/marketplace/CD-PP-DE-MA-01",
            ogTitle: "Mallaustraße 75! Senior ab 25.000 € | CD Real Estate Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate investment with the Club Deal Mallaustraße 75! Senior."
                    : "FINEXITY realisiert mit dem Club Deal Mallaustraße 75! Senior das nächste Immobilien Investment.",
            ogImage: `/docs/social/FINEXITY_Mallaustraße_75_Senior_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Mallaustraße_75_Senior_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Mallaustraße_75_Senior_CD_OG.png`,
        },
        "CD-PP-DE-MA-02": {
            ogURL: "/marketplace/CD-PP-DE-MA-02",
            ogTitle: "Mallaustraße 75! Junior ab 5.000 € | CD Real Estate Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate investment with the Club Deal Mallaustraße 75! Junior."
                    : "FINEXITY realisiert mit dem Club Deal Mallaustraße 75! Junior das nächste Immobilien Investment.",
            ogImage: `/docs/social/FINEXITY_Mallaustraße_75_Junior_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Mallaustraße_75_Junior_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Mallaustraße_75_Junior_CD_OG.png`,
        },
        "WA-PP-02": {
            ogURL: "/marketplace/WA-PP-02",
            ogTitle: "Patek Philippe Nautilus 3710/1A | Watches Investment",
            ogDescription:
                locale === "en"
                    ? "Watches investment product Patek Philippe Nautilus 3710/1A. Investors can participate in the form of investment token from 500 euros."
                    : "Luxusuhren Investment Patek Philippe Nautilus 3710/1A. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/Patek_Philippe_Nautilus_3710-1A_OG.png`,
            ogImageURL: `/docs/social/Patek_Philippe_Nautilus_3710-1A_OG.png`,
            twitterImage: `/docs/social/Patek_Philippe_Nautilus_3710-1A_OG.png`,
        },
        "CD-PP-WA-PP-02": {
            ogURL: "/marketplace/CD-PP-WA-PP-02",
            ogTitle: "Patek Philippe Nautilus 3710/1A | Watches Investment",
            ogDescription:
                locale === "en"
                    ? "Watches investment product Patek Philippe Nautilus 3710/1A."
                    : "Luxusuhren Investment Patek Philippe Nautilus 3710/1A.",
            ogImage: `/docs/social/FINEXITY_Patek_Philippe_Nautilus_3710-1A_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Patek_Philippe_Nautilus_3710-1A_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Patek_Philippe_Nautilus_3710-1A_OG.png`,
        },
        "DI-FP-02": {
            ogURL: "/marketplace/DI-FP-02",
            ogTitle:
                locale === "en"
                    ? "Fancy Intense Purple Pink Duo Diamonds | Diamond Investment"
                    : "Fancy Intense Purple Pink Duo Diamanten | Diamanten Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next diamond investment with a Fancy Intense Purple Pink Duo. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit einem Fancy Intense Purple Pink Duo das nächste Diamanten Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Fancy_Intense_Purple_Pink_Duo_Diamond_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Fancy_Intense_Purple_Pink_Duo_Diamond_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Fancy_Intense_Purple_Pink_Duo_Diamond_OG.png`,
        },
        "SI-JV-01": {
            ogURL: "/marketplace/SI-JV-01",
            ogTitle:
                locale === "en"
                    ? "Vuillaume 1855 Violin | String Instrument"
                    : "Vuillaume 1855 Violine | Streichinstrument Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises with the Vuillaume 1855 Violin the first string instrument investment. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit der Vuillaume 1855 das erste Violinen Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Vuillaume_1855_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Vuillaume_1855_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Vuillaume_1855_OG.png`,
        },
        "CD-PP-SI-JV-01": {
            ogURL: "/marketplace/CD-PP-SI-JV-01",
            ogTitle:
                locale === "en"
                    ? "Vuillaume 1855 Violin | String Instrument"
                    : "Vuillaume 1855 Violine | Streichinstrument Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises with the Vuillaume 1855 violin the first string instrument investment."
                    : "FINEXITY realisiert mit der Violine Vuillaume 1855 das erste Streichinstrument Investment.",
            ogImage: `/docs/social/FINEXITY_Vuillaume_1855_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Vuillaume_1855_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Vuillaume_1855_CD_OG.png`,
        },
        "WA-PP-03": {
            ogURL: "/marketplace/WA-PP-03",
            ogTitle: "Patek Philippe Worldtimer | Watches Investment",
            ogDescription:
                locale === "en"
                    ? "Watches investment product Patek Philippe Worldtimer. Investors can participate in the form of investment token from 500 euros."
                    : "Luxusuhren Investment Patek Philippe Worldtimer. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/Patek_Philippe_Worldtimer_OG.png`,
            ogImageURL: `/docs/social/Patek_Philippe_Worldtimer_OG.png`,
            twitterImage: `/docs/social/Patek_Philippe_Worldtimer_OG.png`,
        },
        "FW-BP-01": {
            ogURL: "/marketplace/FW-BP-01",
            ogTitle: "Bordeaux Finest Selection Portfolio | Fine Wine Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine wine investment with a Bordeaux Finest Selection Portfolio. Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY realisiert mit einem Bordeaux Finest Selection Portfolio das nächste Fine Wine Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Bordeaux_Finest_Selection_Portfolio_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Bordeaux_Finest_Selection_Portfolio_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Bordeaux_Finest_Selection_Portfolio_OG.png`,
        },
        "WA-PP-04": {
            ogURL: "/marketplace/WA-PP-04",
            ogTitle:
                locale === "en"
                    ? "Patek Philippe Nautilus Moon | Watches Investment"
                    : "Patek Philippe Nautilus Mond | Luxusuhren Investment",
            ogDescription:
                locale === "en"
                    ? "Watches investment product Patek Philippe Nautilus Moon. Investors can participate in the form of investment token from 500 euros."
                    : "Luxusuhren Investment Patek Philippe Nautilus Mond. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/Patek_Philippe_Moonphase_OG.png`,
            ogImageURL: `/docs/social/Patek_Philippe_Moonphase_OG.png`,
            twitterImage: `/docs/social/Patek_Philippe_Moonphase_OG.png`,
        },
        "FA-BA-02": {
            ogURL: "/marketplace/FA-BA-02",
            ogTitle: "Bansky - Choose Your Weapon (2010) Portfolio | Fine Art Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine art investment with a Choose Your Weapon (2010) Portfolio by Banksy. Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY realisiert mit einem Choose Your Weapon (2010) Portfolio von Bansky das nächste Fine Art Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Choose_Your_Weapon_2010_Portfolio_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Choose_Your_Weapon_2010_Portfolio_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Choose_Your_Weapon_2010_Portfolio_OG.png`,
        },
        "CD-PP-FA-BA-02": {
            ogURL: "/marketplace/CD-PP-FA-BA-02",
            ogTitle: "Bansky - Choose Your Weapon (2010) Portfolio | Fine Art Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine art investment with a Choose Your Weapon (2010) Portfolio by Banksy."
                    : "FINEXITY realisiert mit einem Choose Your Weapon (2010) Portfolio von Bansky das nächste Fine Art Investment.",
            ogImage: `/docs/social/FINEXITY_Choose_Your_Weapon_2010_Portfolio_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Choose_Your_Weapon_2010_Portfolio_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Choose_Your_Weapon_2010_Portfolio_CD_OG.png`,
        },
        "WA-PP-05": {
            ogURL: "/marketplace/WA-PP-05",
            ogTitle:
                locale === "en"
                    ? "Patek Philippe Nautilus Rêve Rosé | Watches Investment"
                    : "Patek Philippe Nautilus Rêve Rosé | Luxusuhren Investment",
            ogDescription:
                locale === "en"
                    ? "Watches investment product Patek Philippe Nautilus Rêve Rosé. Investors can participate in the form of investment token from 500 euros."
                    : "Luxusuhren Investment Patek Philippe Nautilus Rêve Rosé. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/Patek_Philippe_Nautilus_Reve_Rose_OG.png`,
            ogImageURL: `/docs/social/Patek_Philippe_Nautilus_Reve_Rose_OG.png`,
            twitterImage: `/docs/social/Patek_Philippe_Nautilus_Reve_Rose_OG.png`,
        },
        "DI-FP-03": {
            ogURL: "/marketplace/DI-FP-03",
            ogTitle:
                locale === "en"
                    ? "Fancy Intense Pink Emerald Cut 0.40 ct | Diamond Investment"
                    : "Fancy Intense Pink Emerald Cut 0,40 ct | Diamanten Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next diamond investment with a Fancy Intense Pink Emerald Cut 0.40 ct. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit einem Fancy Intense Pink Emerald Cut 0,40 ct das nächste Diamanten Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Fancy_Intense_Pink_Emerald_Cut_Diamond_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Fancy_Intense_Pink_Emerald_Cut_Diamond_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Fancy_Intense_Pink_Emerald_Cut_Diamond_OG.png`,
        },
        "CD-PP-DE-MA-03": {
            ogURL: "/marketplace/CD-PP-DE-MA-03",
            ogTitle: "Mallaustraße 75! Spezial-Investor | CD Real Estate Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate investment with the Club Deal Mallaustraße 75! Spezial-Investor."
                    : "FINEXITY realisiert mit dem Club Deal Mallaustraße 75! Spezial-Investor das nächste Immobilien Investment.",
            ogImage: `/docs/social/FINEXITY_Mallaustraße_75_Senior_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Mallaustraße_75_Senior_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Mallaustraße_75_Senior_CD_OG.png`,
        },
        "SI-DP-01": {
            ogURL: "/marketplace/SI-DP-01",
            ogTitle:
                locale === "en"
                    ? "Dominique Peccatte Bow (1845) | String Instrument"
                    : "Dominique Peccatte Bogen (1845) | Streichinstrument Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises with the Dominique Peccatte Bow (1845) the first string instrument investment. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit der Dominique Peccatte Bow (1845) das erste Violinenbogen Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Dominique_Peccatte_Bow_1845_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Dominique_Peccatte_Bow_1845_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Dominique_Peccatte_Bow_1845_OG.png`,
        },
        "CD-PP-SI-DP-01": {
            ogURL: "/marketplace/CD-PP-SI-DP-01",
            ogTitle:
                locale === "en"
                    ? "Dominique Peccatte Bow (1845) | String Instrument"
                    : "Dominique Peccatte Bogen (1845) | Streichinstrument Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises with the Dominique Peccatte Bow (1845) the first string instrument investment."
                    : "FINEXITY realisiert mit der Dominique Peccatte Bow (1845) das erste Violinenbogen Investment.",
            ogImage: `/docs/social/FINEXITY_Dominique_Peccatte_Bow_1845_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Dominique_Peccatte_Bow_1845_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Dominique_Peccatte_Bow_1845_OG.png`,
        },
        "DE-HH-10": {
            ogURL: "/marketplace/DE-HH-10",
            ogTitle: "Uphoffweg! Hamburg | Real Estate Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate investment with the Uphoffweg! Hamburg. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit dem Uphoffweg! Hamburg das nächste Immobilien Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Uphoffweg_Hamburg_Retail_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Uphoffweg_Hamburg_Retail_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Uphoffweg_Hamburg_Retail_OG.png`,
        },
        "CD-PP-DE-HH-10": {
            ogURL: "/marketplace/CD-PP-DE-HH-10",
            ogTitle: "Uphoffweg! Hamburg CD Junior | Real Estate Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate investment with the Uphoffweg! Hamburg CD Junior."
                    : "FINEXITY realisiert mit dem Uphoffweg! Hamburg CD Junior das nächste Immobilien Investment.",
            ogImage: `/docs/social/FINEXITY_Uphoffweg_Hamburg_CD_Junior_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Uphoffweg_Hamburg_CD_Junior_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Uphoffweg_Hamburg_CD_Junior_OG.png`,
        },
        "CD-PP-DE-HH-11": {
            ogURL: "/marketplace/CD-PP-DE-HH-11",
            ogTitle: "Uphoffweg! Hamburg CD Senior | Real Estate Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate investment with the Uphoffweg! Hamburg CD Senior."
                    : "FINEXITY realisiert mit dem Uphoffweg! Hamburg CD Senior das nächste Immobilien Investment.",
            ogImage: `/docs/social/FINEXITY_Uphoffweg_Hamburg_CD_Senior_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Uphoffweg_Hamburg_CD_Senior_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Uphoffweg_Hamburg_CD_Senior_OG.png`,
        },
        "WA-RX-02": {
            ogURL: "/marketplace/WA-RX-02",
            ogTitle: "Rolex Professional Collection | Watches Investment",
            ogDescription:
                locale === "en"
                    ? "Watches investment product Rolex Professional Collection. Investors can participate in the form of investment token from 500 euros."
                    : "Luxusuhren Investment Rolex Professional Collection. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Rolex_Professional_Collection_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Rolex_Professional_Collection_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Rolex_Professional_Collection_OG.png`,
        },
        "FA-IK-01": {
            ogURL: "/marketplace/FA-IK-01",
            ogTitle: "Baseler Fenster (2020) | Fine Art Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine art investment with the Baseler Fenster (2020) by Imi Knoebel. Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY realisiert mit Baseler Fenster (2020) von Imi Knoebel das nächste Fine Art Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Baseler_Fenster_Imi_Knoebel_2020_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Baseler_Fenster_Imi_Knoebel_2020_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Baseler_Fenster_Imi_Knoebel_2020_OG.png`,
        },
        "CD-PP-FA-IK-01": {
            ogURL: "/marketplace/CD-PP-FA-IK-01",
            ogTitle: "Baseler Fenster (2020) Club | Fine Art Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine art investment with the Baseler Fenster (2020) Club by Imi Knoebel."
                    : "FINEXITY realisiert mit Baseler Fenster (2020) Club von Imi Knoebel das nächste Fine Art Investment.",
            ogImage: `/docs/social/FINEXITY_Baseler_Fenster_Imi_Knoebel_2020_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Baseler_Fenster_Imi_Knoebel_2020_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Baseler_Fenster_Imi_Knoebel_2020_CD_OG.png`,
        },
        "WA-PP-06": {
            ogURL: "/marketplace/WA-PP-06",
            ogTitle:
                locale === "en"
                    ? "Patek Philippe Perpetual Calendar | Watches Investment"
                    : "Patek Philippe Perpetual Calendar | Luxusuhren Investment",
            ogDescription:
                locale === "en"
                    ? "Watches investment product Patek Philippe Perpetual Calendar. Investors can participate in the form of investment token from 500 euros."
                    : "Luxusuhren Investment Patek Philippe Perpetual Calendar. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/Patek_Philippe_Perpetual_Calendar_OG.png`,
            ogImageURL: `/docs/social/Patek_Philippe_Perpetual_Calendar_OG.png`,
            twitterImage: `/docs/social/Patek_Philippe_Perpetual_Calendar_OG.png`,
        },
        "CD-PP-WA-PP-06": {
            ogURL: "/marketplace/CD-PP-WA-PP-06",
            ogTitle:
                locale === "en"
                    ? "Patek Philippe Perpetual Calendar Club | Watches Investment"
                    : "Patek Philippe Perpetual Calendar Club | Luxusuhren Investment",
            ogDescription:
                locale === "en"
                    ? "Watches investment product Patek Philippe Perpetual Calendar Club."
                    : "Luxusuhren Investment Patek Philippe Perpetual Calendar Club.",
            ogImage: `/docs/social/Patek_Philippe_Perpetual_Calendar_Club_OG.png`,
            ogImageURL: `/docs/social/Patek_Philippe_Perpetual_Calendar_Club_OG.png`,
            twitterImage: `/docs/social/Patek_Philippe_Perpetual_Calendar_Club_OG.png`,
        },
        "FW-TR-01": {
            ogURL: "/marketplace/FW-TR-01",
            ogTitle: "Taittinger Comtes de Champagne Rosé (2007) | Fine Wine Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine wine investment with a Taittinger Comtes de Champagne Rosé (2007). Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY realisiert mit einem Taittinger Comtes de Champagne Rosé (2007) das nächste Fine Wine Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Taittinger_Comtes_Champagne_Rose_2007_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Taittinger_Comtes_Champagne_Rose_2007_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Taittinger_Comtes_Champagne_Rose_2007_OG.png`,
        },
        "CD-PP-DI-RD-01": {
            ogURL: "/marketplace/CD-PP-DI-RD-01",
            ogTitle:
                locale === "en"
                    ? "White Rough Diamond 15,07 ct | Diamond Investment"
                    : "White Rough Diamond 15,07 ct | Diamanten Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next diamond investment with a White Rough Diamond 15,07 ct."
                    : "FINEXITY realisiert mit einem White Rough Diamond 15,07 ct das nächste Diamanten Investment.",
            ogImage: `/docs/social/FINEXITY_White_Rough_15-07_Diamond_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_White_Rough_15-07_Diamond_OG.png`,
            twitterImage: `/docs/social/FINEXITY_White_Rough_15-07_Diamond_OG.png`,
        },
        "FAIRZINSUNG-01": {
            ogURL: "/marketplace/FAIRZINSUNG-01",
            ogTitle: "Solar-Anleihe Willofs II 2025 | Renewables",
        },
        "FAIRZINSUNG-02": {
            ogURL: "/marketplace/FAIRZINSUNG-02",
            ogTitle: "Solar-Anleihe Aßlar 2025 | Renewables",
        },
        "FAIRZINSUNG-03": {
            ogURL: "/marketplace/FAIRZINSUNG-03",
            ogTitle: "Restore – Wasserkraft-Anleihe 2026 | Renewables",
        },
        "FAIRZINSUNG-04": {
            ogURL: "/marketplace/FAIRZINSUNG-04",
            ogTitle: "Solar-Anleihe Bellersdorf I 2023 | Renewables",
        },
        "ES-MA-02": {
            ogURL: "/marketplace/ES-MA-02",
            ogTitle: locale === "en" ? "Nova One! Mallorca | Luxury Villa" : "Nova One! Mallorca | Luxusvilla",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate project with a luxury villa in Bunyola, Mallorca (Spain). Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert ein weiteres Immobilienprojekt mit einer Luxusvilla in Bunyola, Mallorca (Spanien). Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Nova_One_Bunyola_NOR_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Nova_One_Bunyola_NOR_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Nova_One_Bunyola_NOR_OG.png`,
        },
        "CD-PP-ES-MA-03": {
            ogURL: "/marketplace/CD-PP-ES-MA-03",
            ogTitle: locale === "en" ? "Nova One! Mallorca | Luxury Villa" : "Nova One! Mallorca | Luxusvilla",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate project with a luxury villa in Bunyola, Mallorca (Spain). Investors can participate in the form of investment tokens from 5,000 euros."
                    : "FINEXITY realisiert ein weiteres Immobilienprojekt mit einer Luxusvilla in Bunyola, Mallorca (Spanien). Anleger können sich ab 5.000 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Nova_One_Bunyola_NOJ_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Nova_One_Bunyola_NOJ_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Nova_One_Bunyola_NOJ_OG.png`,
        },
        "CD-PP-ES-MA-04": {
            ogURL: "/marketplace/CD-PP-ES-MA-04",
            ogTitle: locale === "en" ? "Nova One! Mallorca | Luxury Villa" : "Nova One! Mallorca | Luxusvilla",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate project with a luxury villa in Bunyola, Mallorca (Spain)."
                    : "FINEXITY realisiert ein weiteres Immobilienprojekt mit einer Luxusvilla in Bunyola, Mallorca (Spanien).",
            ogImage: `/docs/social/FINEXITY_Nova_One_Bunyola_NOS_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Nova_One_Bunyola_NOS_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Nova_One_Bunyola_NOS_OG.png`,
        },
        "CD-PP-ES-MA-05": {
            ogURL: "/marketplace/CD-PP-ES-MA-05",
            ogTitle: locale === "en" ? "Nova One! Mallorca | Luxury Villa" : "Nova One! Mallorca | Luxusvilla",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate project with a luxury villa in Bunyola, Mallorca (Spain)."
                    : "FINEXITY realisiert ein weiteres Immobilienprojekt mit einer Luxusvilla in Bunyola, Mallorca (Spanien).",
            ogImage: `/docs/social/FINEXITY_Nova_One_Bunyola_NOE_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Nova_One_Bunyola_NOE_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Nova_One_Bunyola_NOE_OG.png`,
        },
        "WA-PP-07": {
            ogURL: "/marketplace/WA-PP-07",
            ogTitle:
                locale === "en"
                    ? "Patek Philippe Aquanaut Luce | Watches Investment"
                    : "Patek Philippe Aquanaut Luce | Luxusuhren Investment",
            ogDescription:
                locale === "en"
                    ? "Watches investment product Patek Philippe Aquanaut Luce. Investors can participate in the form of investment token from 500 euros."
                    : "Luxusuhren Investment Patek Philippe Aquanaut Luce. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/Patek_Philippe_Aquanaut_Luce_OG.png`,
            ogImageURL: `/docs/social/Patek_Philippe_Aquanaut_Luce_OG.png`,
            twitterImage: `/docs/social/Patek_Philippe_Aquanaut_Luce_OG.png`,
        },
        "SI-DP-02": {
            ogURL: "/marketplace/SI-DP-02",
            ogTitle:
                locale === "en"
                    ? "Dominique Peccatte Cello Bow (1845) | String Instrument"
                    : "Dominique Peccatte Cello Bogen (1845) | Streichinstrument Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises with the Dominique Peccatte Cello Bow (1845) the first string instrument investment. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit der Dominique Peccatte Cello Bow (1845) das erste Violinenbogen Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Dominique_Peccatte_Cello_Bow_1845_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Dominique_Peccatte_Cello_Bow_1845_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Dominique_Peccatte_Cello_Bow_1845_OG.png`,
        },
        "CD-PP-SI-DP-02": {
            ogURL: "/marketplace/CD-PP-SI-DP-02",
            ogTitle:
                locale === "en"
                    ? "Dominique Peccatte Cello Bow (1845) | String Instrument"
                    : "Dominique Peccatte Cello Bogen (1845) | Streichinstrument Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises with the Dominique Peccatte Cello Bow (1845) the first string instrument investment."
                    : "FINEXITY realisiert mit der Dominique Peccatte Cello Bow (1845) das erste Violinenbogen Investment.",
            ogImage: `/docs/social/FINEXITY_Dominique_Peccatte_Cello_Bow_1845_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Dominique_Peccatte_Cello_Bow_1845_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Dominique_Peccatte_Cello_Bow_1845_OG.png`,
        },
        "CD-PP-SI-DP-04": {
            ogURL: "/marketplace/CD-PP-SI-DP-04",
            ogTitle:
                locale === "en"
                    ? "Dominique Peccatte! Junior | String Instrument"
                    : "Dominique Peccatte! Junior | Streichinstrument Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises with the Dominique Peccatte! Junior the first string instrument investment."
                    : "FINEXITY realisiert mit der Dominique Peccatte! Junior das erste Violinenbogen Investment.",
            ogImage: `/docs/social/FINEXITY_Dominique_Peccatte_Cello_Bow_1845_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Dominique_Peccatte_Cello_Bow_1845_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Dominique_Peccatte_Cello_Bow_1845_OG.png`,
        },
        "RE-EG-01": {
            ogURL: "/marketplace/RE-EG-01",
            ogTitle:
                locale === "en" ? "VEG eG EnergyHub | Renewables Investment" : "EnergyHub der VEG eG | Renewables Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises with the Dominique Peccatte Cello Bow (1845) the first string instrument investment. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit der Dominique Peccatte Cello Bow (1845) das erste Violinenbogen Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_EnergyHub_VEG_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_EnergyHub_VEG_OG.png`,
            twitterImage: `/docs/social/FINEXITY_EnergyHub_VEG_OG.png`,
        },
        "CD-PP-RE-EG-01": {
            ogURL: "/marketplace/CD-PP-RE-EG-01",
            ogTitle:
                locale === "en" ? "VEG eG EnergyHub | Renewables Investment" : "EnergyHub der VEG eG | Renewables Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises with the VEG eG EnergyHubs the first renewables investment. Investors can participate in the form of investment tokens from 5,000 euros."
                    : "FINEXITY realisiert mit den EnergyHubs der VEG eG das erste Renewables Investment. Anleger können sich ab 5.000 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_EnergyHub_VEG_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_EnergyHub_VEG_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_EnergyHub_VEG_CD_OG.png`,
        },
        "CD-PP-RE-EG-02": {
            ogURL: "/marketplace/CD-PP-RE-EG-02",
            ogTitle:
                locale === "en" ? "VEG eG EnergyHub | Renewables Investment" : "EnergyHub der VEG eG | Renewables Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises with the VEG eG EnergyHubs the first renewables investment. Investors can participate in the form of investment tokens from 25,000 euros."
                    : "FINEXITY realisiert mit den EnergyHubs der VEG eG das erste Renewables Investment. Anleger können sich ab 25.000 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_EnergyHub_VEG_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_EnergyHub_VEG_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_EnergyHub_VEG_CD_OG.png`,
        },
        "WA-RX-03": {
            ogURL: "/marketplace/WA-RX-03",
            ogTitle: "Rolex Marine Collection | Watches Investment",
            ogDescription:
                locale === "en"
                    ? "Watches investment product Rolex Marine Collection. Investors can participate in the form of investment token from 500 euros."
                    : "Luxusuhren Investment Rolex Marine Collection. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Rolex_Marine_Collection_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Rolex_Marine_Collection_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Rolex_Marine_Collection_OG.png`,
        },
        "CD-PP-FA-SB-01": {
            ogURL: "/marketplace/CD-PP-FA-SB-01",
            ogTitle: "Stephan Balkenhol – Bronze Collection | Fine Art Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine art investment with the Bronze Collection Club by Stephan Balkenhol."
                    : "FINEXITY realisiert mit Bronze Collection Club von Stephan Balkenhol das nächste Fine Art Investment.",
            ogImage: `/docs/social/FINEXITY_Bronze_Collection_Stephan_Balkenhol_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Bronze_Collection_Stephan_Balkenhol_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Bronze_Collection_Stephan_Balkenhol_CD_OG.png`,
        },
        "FW-JP-01": {
            ogURL: "/marketplace/FW-JP-01",
            ogTitle: "Judgement of Paris Portfolio | Fine Wine Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine wine investment with the 'Judgement of Paris' Portfolio."
                    : "FINEXITY realisiert mit dem 'Judgement of Paris' Portfolio das nächste Fine Wine Investment.",
            ogImage: `/docs/social/FINEXITY_Judgement_Paris_Portfolio_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Judgement_Paris_Portfolio_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Judgement_Paris_Portfolio_OG.png`,
        },
        "CD-PP-FW-JP-01": {
            ogURL: "/marketplace/CD-PP-FW-JP-01",
            ogTitle: "Judgement of Paris Portfolio Club | Fine Wine Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine wine investment with the 'Judgement of Paris' Portfolio."
                    : "FINEXITY realisiert mit dem 'Judgement of Paris' Portfolio das nächste Fine Wine Investment.",
            ogImage: `/docs/social/FINEXITY_Judgement_Paris_Portfolio_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Judgement_Paris_Portfolio_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Judgement_Paris_Portfolio_CD_OG.png`,
        },
        "WA-PP-08": {
            ogURL: "/marketplace/WA-PP-08",
            ogTitle:
                locale === "en"
                    ? "Patek Philippe Nautilus 5711 Rosé | Watches Investment"
                    : "Patek Philippe Nautilus 5711 Rosé | Luxusuhren Investment",
            ogDescription:
                locale === "en"
                    ? "Watches investment product Patek Philippe Nautilus 5711 Rosé. Investors can participate in the form of investment token from 500 euros."
                    : "Luxusuhren Investment Patek Philippe Nautilus 5711 Rosé. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/Patek_Philippe_Nautilus_5711_Rose_OG.png`,
            ogImageURL: `/docs/social/Patek_Philippe_Nautilus_5711_Rose_OG.png`,
            twitterImage: `/docs/social/Patek_Philippe_Nautilus_5711_Rose_OG.png`,
        },
        "CD-PP-WA-PP-08": {
            ogURL: "/marketplace/CD-PP-WA-PP-08",
            ogTitle:
                locale === "en"
                    ? "Patek Philippe Nautilus 5711 Rosé | Watches Investment"
                    : "Patek Philippe Nautilus 5711 Rosé | Luxusuhren Investment",
            ogDescription:
                locale === "en"
                    ? "Watches investment product Patek Philippe Nautilus 5711 Rosé. Investors can participate in the form of investment token from 5,000 euros."
                    : "Luxusuhren Investment Patek Philippe Nautilus 5711 Rosé. Anleger können sich ab 5.000 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/Patek_Philippe_Nautilus_5711_Rose_CD_OG.png`,
            ogImageURL: `/docs/social/Patek_Philippe_Nautilus_5711_Rose_CD_OG.png`,
            twitterImage: `/docs/social/Patek_Philippe_Nautilus_5711_Rose_CD_OG.png`,
        },
        "WA-RX-04": {
            ogURL: "/marketplace/WA-RX-04",
            ogTitle:
                locale === "en"
                    ? "Rolex Sky-Dweller Boutique Edition | Watches Investment"
                    : "Rolex Sky-Dweller Boutique Edition | Luxusuhren Investment",
            ogDescription:
                locale === "en"
                    ? "Watches investment product Rolex Sky-Dweller Boutique Edition. Investors can participate in the form of investment token from 500 euros."
                    : "Luxusuhren Investment Rolex Sky-Dweller Boutique Edition. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/Rolex_Sky_Dweller_Boutique_Edition_OG.png`,
            ogImageURL: `/docs/social/Rolex_Sky_Dweller_Boutique_Edition_OG.png`,
            twitterImage: `/docs/social/Rolex_Sky_Dweller_Boutique_Edition_OG.png`,
        },
        "CD-PP-WA-RX-04": {
            ogURL: "/marketplace/CD-PP-WA-RX-04",
            ogTitle:
                locale === "en"
                    ? "Rolex Sky-Dweller Boutique Edition Junior | Watches Investment"
                    : "Rolex Sky-Dweller Boutique Edition Junior | Luxusuhren Investment",
            ogDescription:
                locale === "en"
                    ? "Watches investment product Rolex Sky-Dweller Boutique Edition (Junior). Investors can participate in the form of investment token from 5,000 euros."
                    : "Luxusuhren Investment Rolex Sky-Dweller Boutique Edition (Junior). Anleger können sich ab 5.000 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/Rolex_Sky_Dweller_Boutique_Edition_CD_OG.png`,
            ogImageURL: `/docs/social/Rolex_Sky_Dweller_Boutique_Edition_CD_OG.png`,
            twitterImage: `/docs/social/Rolex_Sky_Dweller_Boutique_Edition_CD_OG.png`,
        },
        "CD-PP-WA-RX-05": {
            ogURL: "/marketplace/CD-PP-WA-RX-05",
            ogTitle:
                locale === "en"
                    ? "Rolex Sky-Dweller Boutique Edition Senior | Watches Investment"
                    : "Rolex Sky-Dweller Boutique Edition Senior | Luxusuhren Investment",
            ogDescription:
                locale === "en"
                    ? "Watches investment product Rolex Sky-Dweller Boutique Edition (Senior). Investors can participate in the form of investment token from 25,000 euros."
                    : "Luxusuhren Investment Rolex Sky-Dweller Boutique Edition (Senior). Anleger können sich ab 25.000 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/Rolex_Sky_Dweller_Boutique_Edition_CD_OG.png`,
            ogImageURL: `/docs/social/Rolex_Sky_Dweller_Boutique_Edition_CD_OG.png`,
            twitterImage: `/docs/social/Rolex_Sky_Dweller_Boutique_Edition_CD_OG.png`,
        },
        "FA-JY-01": {
            ogURL: "/marketplace/FA-JY-01",
            ogTitle: "Yturralde Vibrant Collection | Fine Art Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine art investment with the Yturralde Vibrant Collection by José Maria Yturralde. Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY realisiert mit der Yturralde Vibrant Collection von José Maria Yturralde das nächste Fine Art Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_JM_Yturralde_Vibrant_Collection_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_JM_Yturralde_Vibrant_Collection_OG.png`,
            twitterImage: `/docs/social/FINEXITY_JM_Yturralde_Vibrant_Collection_OG.png`,
        },
        "FW-US-01": {
            ogURL: "/marketplace/FW-US-01",
            ogTitle: "American Excellence Portfolio | Fine Wine Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine wine investment with the American Excellence Portfolio."
                    : "FINEXITY realisiert mit dem American Excellence Portfolio das nächste Fine Wine Investment.",
            ogImage: `/docs/social/FINEXITY_American_Excellence_Portfolio_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_American_Excellence_Portfolio_OG.png`,
            twitterImage: `/docs/social/FINEXITY_American_Excellence_Portfolio_OG.png`,
        },
        "DI-WD-01": {
            ogURL: "/marketplace/DI-WD-01",
            ogTitle:
                locale === "en"
                    ? "Round Brilliant Cut Duo | Diamond Investment"
                    : "Round Brilliant Cut Duo | Diamanten Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next diamond investment with a Round Brilliant Cut Duo."
                    : "FINEXITY realisiert mit einem Round Brilliant Cut Duo das nächste Diamanten Investment.",
            ogImage: `/docs/social/FINEXITY_Round_Brilliant_Cut_Duo_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Round_Brilliant_Cut_Duo_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Round_Brilliant_Cut_Duo_OG.png`,
        },
        "CD-PP-DI-WD-01": {
            ogURL: "/marketplace/CD-PP-DI-WD-01",
            ogTitle:
                locale === "en"
                    ? "Round Brilliant Cut Duo | Diamond Investment"
                    : "Round Brilliant Cut Duo | Diamanten Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next diamond investment with a Round Brilliant Cut Duo."
                    : "FINEXITY realisiert mit einem Round Brilliant Cut Duo das nächste Diamanten Investment.",
            ogImage: `/docs/social/FINEXITY_Round_Brilliant_Cut_Duo_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Round_Brilliant_Cut_Duo_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Round_Brilliant_Cut_Duo_CD_OG.png`,
        },
        "CD-PP-FA-TC-01": {
            ogURL: "/marketplace/CD-PP-FA-TC-01",
            ogTitle: "Tony Cragg - Senders II (2017) & Senders III (2018) | Fine Art Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine art investment with the Senders II (2017) & Senders III (2018) by Tony Cragg. Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY realisiert mit Senders II (2017) & Senders III (2018) von Tony Cragg das nächste Fine Art Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Tony_Cragg_Senders_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Tony_Cragg_Senders_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Tony_Cragg_Senders_CD_OG.png`,
        },
        "ASSETTA-02": {
            ogURL: "/marketplace/ASSETTA-02",
            ogTitle:
                locale === "en"
                    ? "Aurora One! Camp de Mar, Mallorca | Luxury Villa"
                    : "Aurora One! Camp de Mar, Mallorca | Luxusvilla",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate project with a luxury villa in Camp de Mar, Mallorca (Spain)."
                    : "FINEXITY realisiert ein weiteres Immobilienprojekt mit einer Luxusvilla in Camp de Mar, Mallorca (Spanien).",
            ogImage: `/docs/social/FINEXITY_Aurora_One_Camp_de_Mar_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Aurora_One_Camp_de_Mar_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Aurora_One_Camp_de_Mar_OG.png`,
        },
        "ASSETTA-02-01": {
            ogURL: "/marketplace/ASSETTA-02-01",
            ogTitle:
                locale === "en"
                    ? "Aurora One! Camp de Mar, Mallorca | Luxury Villa"
                    : "Aurora One! Camp de Mar, Mallorca | Luxusvilla",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate project with a luxury villa in Camp de Mar, Mallorca (Spain)."
                    : "FINEXITY realisiert ein weiteres Immobilienprojekt mit einer Luxusvilla in Camp de Mar, Mallorca (Spanien).",
            ogImage: `/docs/social/FINEXITY_Aurora_One_Camp_de_Mar_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Aurora_One_Camp_de_Mar_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Aurora_One_Camp_de_Mar_OG.png`,
        },
        "ASSETTA-02-01": {
            ogURL: "/marketplace/ASSETTA-02-01",
            ogTitle:
                locale === "en"
                    ? "Aurora One! Camp de Mar, Mallorca | Luxury Villa"
                    : "Aurora One! Camp de Mar, Mallorca | Luxusvilla",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate project with a luxury villa in Camp de Mar, Mallorca (Spain)."
                    : "FINEXITY realisiert ein weiteres Immobilienprojekt mit einer Luxusvilla in Camp de Mar, Mallorca (Spanien).",
            ogImage: `/docs/social/FINEXITY_Aurora_One_Camp_de_Mar_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Aurora_One_Camp_de_Mar_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Aurora_One_Camp_de_Mar_OG.png`,
        },
        "CD-PP-ASSETTA-02-01": {
            ogURL: "/marketplace/CD-PP-ASSETTA-02-01",
            ogTitle:
                locale === "en"
                    ? "Aurora One! Camp de Mar, Mallorca - Club Deal Junior | Luxury Villa"
                    : "Aurora One! Camp de Mar, Mallorca - Club Deal Junior | Luxusvilla",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate project with a luxury villa in Camp de Mar, Mallorca (Spain)."
                    : "FINEXITY realisiert ein weiteres Immobilienprojekt mit einer Luxusvilla in Camp de Mar, Mallorca (Spanien).",
            ogImage: `/docs/social/FINEXITY_Aurora_One_Camp_de_Mar_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Aurora_One_Camp_de_Mar_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Aurora_One_Camp_de_Mar_CD_OG.png`,
        },
        "CD-PP-ASSETTA-02-02": {
            ogURL: "/marketplace/CD-PP-ASSETTA-02-02",
            ogTitle:
                locale === "en"
                    ? "Aurora One! Camp de Mar, Mallorca - Club Deal Advanced | Luxury Villa"
                    : "Aurora One! Camp de Mar, Mallorca - Club Deal Advanced | Luxusvilla",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate project with a luxury villa in Camp de Mar, Mallorca (Spain)."
                    : "FINEXITY realisiert ein weiteres Immobilienprojekt mit einer Luxusvilla in Camp de Mar, Mallorca (Spanien).",
            ogImage: `/docs/social/FINEXITY_Aurora_One_Camp_de_Mar_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Aurora_One_Camp_de_Mar_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Aurora_One_Camp_de_Mar_CD_OG.png`,
        },
        "CD-PP-ASSETTA-02-03": {
            ogURL: "/marketplace/CD-PP-ASSETTA-02-03",
            ogTitle:
                locale === "en"
                    ? "Aurora One! Camp de Mar, Mallorca - Club Deal Senior | Luxury Villa"
                    : "Aurora One! Camp de Mar, Mallorca - Club Deal Senior | Luxusvilla",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate project with a luxury villa in Camp de Mar, Mallorca (Spain)."
                    : "FINEXITY realisiert ein weiteres Immobilienprojekt mit einer Luxusvilla in Camp de Mar, Mallorca (Spanien).",
            ogImage: `/docs/social/FINEXITY_Aurora_One_Camp_de_Mar_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Aurora_One_Camp_de_Mar_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Aurora_One_Camp_de_Mar_CD_OG.png`,
        },
        "CD-PP-ASSETTA-02-04": {
            ogURL: "/marketplace/CD-PP-ASSETTA-02-04",
            ogTitle:
                locale === "en"
                    ? "Aurora One! Camp de Mar, Mallorca - Club Deal Spezial | Luxury Villa"
                    : "Aurora One! Camp de Mar, Mallorca - Club Deal Spezial | Luxusvilla",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate project with a luxury villa in Camp de Mar, Mallorca (Spain)."
                    : "FINEXITY realisiert ein weiteres Immobilienprojekt mit einer Luxusvilla in Camp de Mar, Mallorca (Spanien).",
            ogImage: `/docs/social/FINEXITY_Aurora_One_Camp_de_Mar_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Aurora_One_Camp_de_Mar_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Aurora_One_Camp_de_Mar_CD_OG.png`,
        },
        "FA-EA-01": {
            ogURL: "/marketplace/FA-EA-01",
            ogTitle: "Emerging Artists Portfolio | Fine Art Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine art investment with the Emerging Artists Portfolio. Investors can participate in the form of investment token from 500 euros."
                    : "FINEXITY realisiert mit dem Emerging Artists Portfolio das nächste Fine Art Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Emerging_Artists_Portfolio_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Emerging_Artists_Portfolio_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Emerging_Artists_Portfolio_OG.png`,
        },
        "CD-PP-FA-EA-01": {
            ogURL: "/marketplace/CD-PP-FA-EA-01",
            ogTitle: "Emerging Artists Portfolio Club | Fine Art Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine art investment with the Emerging Artists Portfolio Club. Investors can participate in the form of investment token from 5000 euros."
                    : "FINEXITY realisiert mit dem Emerging Artists Portfolio Club das nächste Fine Art Investment. Anleger können sich ab 5000 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Emerging_Artists_Portfolio_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Emerging_Artists_Portfolio_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Emerging_Artists_Portfolio_CD_OG.png`,
        },
        "CD-PP-PE-SD-01": {
            ogURL: "/marketplace/CD-PP-PE-SD-01",
            ogTitle:
                locale === "en"
                    ? "Acorns Equity Capital Junior | Private Equity Investment"
                    : "Acorns Beteiligungskapital Junior | Private Equity Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next private equity investment with Acorns Equity Capital Junior."
                    : "FINEXITY realisiert mit dem Acorns Beteiligungskapital Junior das nächste Private Equity Investment.",
            ogImage: `/docs/social/FINEXITY_PE_Acorns_Junior_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_PE_Acorns_Junior_OG.png`,
            twitterImage: `/docs/social/FINEXITY_PE_Acorns_Junior_OG.png`,
        },
        "CD-PP-PE-SD-02": {
            ogURL: "/marketplace/CD-PP-PE-SD-02",
            ogTitle:
                locale === "en"
                    ? "Acorns Equity Capital Advanced | Private Equity Investment"
                    : "Acorns Beteiligungskapital Advanced | Private Equity Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next private equity investment with Acorns Equity Capital Advanced."
                    : "FINEXITY realisiert mit dem Acorns Beteiligungskapital Advanced das nächste Private Equity Investment.",
            ogImage: `/docs/social/FINEXITY_PE_Acorns_Advanced_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_PE_Acorns_Advanced_OG.png`,
            twitterImage: `/docs/social/FINEXITY_PE_Acorns_Advanced_OG.png`,
        },
        "CD-PP-PE-SD-03": {
            ogURL: "/marketplace/CD-PP-PE-SD-03",
            ogTitle:
                locale === "en"
                    ? "Acorns Equity Capital Senior | Private Equity Investment"
                    : "Acorns Beteiligungskapital Senior | Private Equity Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next private equity investment with Acorns Equity Capital Senior."
                    : "FINEXITY realisiert mit dem Acorns Beteiligungskapital Senior das nächste Private Equity Investment.",
            ogImage: `/docs/social/FINEXITY_PE_Acorns_Senior_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_PE_Acorns_Senior_OG.png`,
            twitterImage: `/docs/social/FINEXITY_PE_Acorns_Senior_OG.png`,
        },
        "CD-PP-PE-SD-04": {
            ogURL: "/marketplace/CD-PP-PE-SD-04",
            ogTitle:
                locale === "en"
                    ? "Acorns Equity Capital Family | Private Equity Investment"
                    : "Acorns Beteiligungskapital Family | Private Equity Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next private equity investment with Acorns Equity Capital Family."
                    : "FINEXITY realisiert mit dem Acorns Beteiligungskapital Family das nächste Private Equity Investment.",
            ogImage: `/docs/social/FINEXITY_PE_Acorns_Family_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_PE_Acorns_Family_OG.png`,
            twitterImage: `/docs/social/FINEXITY_PE_Acorns_Family_OG.png`,
        },
        "CD-PP-FA-TC-02": {
            ogURL: "/marketplace/CD-PP-FA-TC-02",
            ogTitle: "Tony Cragg: It is it isnt - Junior | Fine Art Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine art investment with the It is it isnt - Junior by Tony Cragg. Investors can participate in the form of investment token from 5000 euros."
                    : "FINEXITY realisiert mit It is it isnt - Junior von Tony Cragg das nächste Fine Art Investment. Anleger können sich ab 5000 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Tony_Cragg_it-is_Junior_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Tony_Cragg_it-is_Junior_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Tony_Cragg_it-is_Junior_CD_OG.png`,
        },
        "CD-PP-FA-TC-03": {
            ogURL: "/marketplace/CD-PP-FA-TC-03",
            ogTitle: "Tony Cragg: It is it isnt - Select | Fine Art Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine art investment with the It is it isnt by Tony Cragg. Investors can participate in the form of investment token from 15000 euros."
                    : "FINEXITY realisiert mit It is it isnt von Tony Cragg das nächste Fine Art Investment. Anleger können sich ab 15000 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Tony_Cragg_it-is_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Tony_Cragg_it-is_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Tony_Cragg_it-is_CD_OG.png`,
        },
        "CD-PP-FA-TC-04": {
            ogURL: "/marketplace/CD-PP-FA-TC-04",
            ogTitle: "Tony Cragg: It is it isnt - Beta | Fine Art Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next fine art investment with the It is it isnt by Tony Cragg. Investors can participate in the form of investment token from 5000 euros."
                    : "FINEXITY realisiert mit It is it isnt von Tony Cragg das nächste Fine Art Investment. Anleger können sich ab 5000 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Tony_Cragg_it-is_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Tony_Cragg_it-is_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Tony_Cragg_it-is_CD_OG.png`,
        },
        "CD-PP-FRD-01-01": {
            ogURL: "/marketplace/CD-PP-FRD-01-01",
            ogTitle:
                locale === "en"
                    ? "Andalusia One! Junior, Marbella | Holiday Apartments"
                    : "Andalusia One! Junior, Marbella | Ferienimmobilie",
            ogDescription:
                locale === "en"
                    ? "FINEXITY expands its product offering with holiday apartments in Marbella, including a fixed minimum interest rate and a maximum term of 12 months."
                    : "FINEXITY erweitert sein Produktangebot um eine Ferienimmobilie in Marbella mit einer festen Mindestverzinsung und max. 12 Monaten Laufzeit.",
            ogImage: `/docs/social/FINEXITY_FRD_Andalusia_One_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_FRD_Andalusia_One_OG.png`,
            twitterImage: `/docs/social/FINEXITY_FRD_Andalusia_One_OG.png`,
        },
        "CD-PP-FRD-01-02": {
            ogURL: "/marketplace/CD-PP-FRD-01-02",
            ogTitle:
                locale === "en"
                    ? "Andalusia One! Advanced, Marbella | Holiday Apartments"
                    : "Andalusia One! Advanced, Marbella | Ferienimmobilie",
            ogDescription:
                locale === "en"
                    ? "FINEXITY expands its product offering with holiday apartments in Marbella, including a fixed minimum interest rate and a maximum term of 12 months."
                    : "FINEXITY erweitert sein Produktangebot um eine Ferienimmobilie in Marbella mit einer festen Mindestverzinsung und max. 12 Monaten Laufzeit.",
            ogImage: `/docs/social/FINEXITY_FRD_Andalusia_One_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_FRD_Andalusia_One_OG.png`,
            twitterImage: `/docs/social/FINEXITY_FRD_Andalusia_One_OG.png`,
        },
        "CD-PP-FRD-01-03": {
            ogURL: "/marketplace/CD-PP-FRD-01-03",
            ogTitle:
                locale === "en"
                    ? "Andalusia One! Beta, Marbella | Holiday Apartments"
                    : "Andalusia One! Beta, Marbella | Ferienimmobilie",
            ogDescription:
                locale === "en"
                    ? "FINEXITY expands its product offering with holiday apartments in Marbella, including a fixed minimum interest rate and a maximum term of 12 months."
                    : "FINEXITY erweitert sein Produktangebot um eine Ferienimmobilie in Marbella mit einer festen Mindestverzinsung und max. 12 Monaten Laufzeit.",
            ogImage: `/docs/social/FINEXITY_FRD_Andalusia_One_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_FRD_Andalusia_One_OG.png`,
            twitterImage: `/docs/social/FINEXITY_FRD_Andalusia_One_OG.png`,
        },
        "SI-AB-01": {
            ogURL: "/marketplace/SI-AB-01",
            ogTitle:
                locale === "en"
                    ? "Brother Amati Violin | String Instrument"
                    : "Brüder Amati Violine | Streichinstrument Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises with the Brother Amati violin the second string instrument investment. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert mit der Brüder Amati Violine das zweite Violinen Investment. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Brother_Amati_1_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Brother_Amati_1_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Brother_Amati_1_OG.png`,
        },
        "CD-PP-SI-AB-01": {
            ogURL: "/marketplace/CD-PP-SI-AB-01",
            ogTitle:
                locale === "en"
                    ? "Brother Amati Violin Junior | String Instrument"
                    : "Brüder Amati Violine Junior | Streichinstrument Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises with the Brother Amati violin the second string instrument investment."
                    : "FINEXITY realisiert mit der Brüder Amati Violine das zweite Streichinstrument Investment.",
            ogImage: `/docs/social/FINEXITY_Brother_Amati_1_OG`,
            ogImageURL: `/docs/social/FINEXITY_Brother_Amati_1_OG`,
            twitterImage: `/docs/social/FINEXITY_Brother_Amati_1_OG`,
        },
        "CD-PP-SI-AB-02": {
            ogURL: "/marketplace/CD-PP-SI-AB-02",
            ogTitle:
                locale === "en"
                    ? "Brother Amati Violin Advanced | String Instrument"
                    : "Brüder Amati Violine Advanced | Streichinstrument Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises with the Brother Amati violin the second string instrument investment."
                    : "FINEXITY realisiert mit der Brüder Amati Violine das zweite Streichinstrument Investment.",
            ogImage: `/docs/social/FINEXITY_Brother_Amati_1_OG`,
            ogImageURL: `/docs/social/FINEXITY_Brother_Amati_1_OG`,
            twitterImage: `/docs/social/FINEXITY_Brother_Amati_1_OG`,
        },
        "CD-PP-SI-AB-03": {
            ogURL: "/marketplace/CD-PP-SI-AB-03",
            ogTitle:
                locale === "en"
                    ? "Brother Amati Violin Beta | String Instrument"
                    : "Brüder Amati Violine Beta | Streichinstrument Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises with the Brother Amati violin the second string instrument investment."
                    : "FINEXITY realisiert mit der Brüder Amati Violine das zweite Streichinstrument Investment.",
            ogImage: `/docs/social/FINEXITY_Brother_Amati_1_OG`,
            ogImageURL: `/docs/social/FINEXITY_Brother_Amati_1_OG`,
            twitterImage: `/docs/social/FINEXITY_Brother_Amati_1_OG`,
        },
        "ASSETTA-03": {
            ogURL: "/marketplace/ASSETTA-03",
            ogTitle:
                locale === "en"
                    ? "Solara One! Camp de Mar, Mallorca | Luxury Villa"
                    : "Solara One! Camp de Mar, Mallorca | Luxusvilla",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate project with a luxury villa in Camp de Mar, Mallorca (Spain)."
                    : "FINEXITY realisiert ein weiteres Immobilienprojekt mit einer Luxusvilla in Camp de Mar, Mallorca (Spanien).",
            ogImage: `/docs/social/FINEXITY_Solara_One_Camp_de_Mar_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Solara_One_Camp_de_Mar_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Solara_One_Camp_de_Mar_CD_OG.png`,
        },
        "CD-PP-ASSETTA-03-01": {
            ogURL: "/marketplace/CD-PP-ASSETTA-03-01",
            ogTitle:
                locale === "en"
                    ? "Solara One! Camp de Mar, Mallorca | Luxury Villa"
                    : "Solara One! Camp de Mar, Mallorca | Luxusvilla",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate project with a luxury villa in Camp de Mar, Mallorca (Spain)."
                    : "FINEXITY realisiert ein weiteres Immobilienprojekt mit einer Luxusvilla in Camp de Mar, Mallorca (Spanien).",
            ogImage: `/docs/social/FINEXITY_Solara_One_Camp_de_Mar_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Solara_One_Camp_de_Mar_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Solara_One_Camp_de_Mar_CD_OG.png`,
        },
        "CD-PP-ASSETTA-03-02": {
            ogURL: "/marketplace/CD-PP-ASSETTA-03-02",
            ogTitle:
                locale === "en"
                    ? "Solara One! Camp de Mar, Mallorca | Luxury Villa"
                    : "Solara One! Camp de Mar, Mallorca | Luxusvilla",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate project with a luxury villa in Camp de Mar, Mallorca (Spain)."
                    : "FINEXITY realisiert ein weiteres Immobilienprojekt mit einer Luxusvilla in Camp de Mar, Mallorca (Spanien).",
            ogImage: `/docs/social/FINEXITY_Solara_One_Camp_de_Mar_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Solara_One_Camp_de_Mar_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Solara_One_Camp_de_Mar_CD_OG.png`,
        },
        "CD-PP-ASSETTA-03-03": {
            ogURL: "/marketplace/CD-PP-ASSETTA-03-03",
            ogTitle:
                locale === "en"
                    ? "Solara One! Camp de Mar, Mallorca | Luxury Villa"
                    : "Solara One! Camp de Mar, Mallorca | Luxusvilla",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate project with a luxury villa in Camp de Mar, Mallorca (Spain)."
                    : "FINEXITY realisiert ein weiteres Immobilienprojekt mit einer Luxusvilla in Camp de Mar, Mallorca (Spanien).",
            ogImage: `/docs/social/FINEXITY_Solara_One_Camp_de_Mar_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Solara_One_Camp_de_Mar_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Solara_One_Camp_de_Mar_CD_OG.png`,
        },
        "CD-PP-ASSETTA-03-04": {
            ogURL: "/marketplace/CD-PP-ASSETTA-03-04",
            ogTitle:
                locale === "en"
                    ? "Solara One! Camp de Mar, Mallorca | Luxury Villa"
                    : "Solara One! Camp de Mar, Mallorca | Luxusvilla",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate project with a luxury villa in Camp de Mar, Mallorca (Spain)."
                    : "FINEXITY realisiert ein weiteres Immobilienprojekt mit einer Luxusvilla in Camp de Mar, Mallorca (Spanien).",
            ogImage: `/docs/social/FINEXITY_Solara_One_Camp_de_Mar_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Solara_One_Camp_de_Mar_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Solara_One_Camp_de_Mar_CD_OG.png`,
        },
        "CD-PP-ASSETTA-03-05": {
            ogURL: "/marketplace/CD-PP-ASSETTA-03-05",
            ogTitle:
                locale === "en"
                    ? "Solara One! Camp de Mar, Mallorca | Luxury Villa"
                    : "Solara One! Camp de Mar, Mallorca | Luxusvilla",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate project with a luxury villa in Camp de Mar, Mallorca (Spain)."
                    : "FINEXITY realisiert ein weiteres Immobilienprojekt mit einer Luxusvilla in Camp de Mar, Mallorca (Spanien).",
            ogImage: `/docs/social/FINEXITY_Solara_One_Camp_de_Mar_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Solara_One_Camp_de_Mar_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Solara_One_Camp_de_Mar_CD_OG.png`,
        },
        "KALONUERNBERG-01": {
            ogURL: "/marketplace/KALONUERNBERG-01",
            ogTitle:
                locale === "en" ? "Kalo Unity Sphere in Nürnberg | Residential" : "Kalo Unity Sphere in Nürnberg | Residential",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate project with Kalo Unity Sphere in Nürnberg."
                    : "FINEXITY realisiert ein weiteres Immobilienprojekt mit der Immobilie Kalo Unity Sphere in Nürnberg.",
            ogImage: `/docs/social/FINEXITY_Kalo_Unity_Sphere_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Kalo_Unity_Sphere_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Kalo_Unity_Sphere_CD_OG.png`,
        },
        "CD-PP-KALONUERNBERG-01-01": {
            ogURL: "/marketplace/CD-PP-KALONUERNBERG-01-01",
            ogTitle:
                locale === "en"
                    ? "Kalo Unity Sphere in Nürnberg | Junior | Residential"
                    : "Kalo Unity Sphere in Nürnberg | Junior | Residential",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate project with Kalo Unity Sphere in Nürnberg."
                    : "FINEXITY realisiert ein weiteres Immobilienprojekt mit der Immobilie Kalo Unity Sphere in Nürnberg.",
            ogImage: `/docs/social/FINEXITY_Kalo_Unity_Sphere_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Kalo_Unity_Sphere_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Kalo_Unity_Sphere_CD_OG.png`,
        },
        "CD-PP-KALONUERNBERG-01-02": {
            ogURL: "/marketplace/CD-PP-KALONUERNBERG-01-02",
            ogTitle:
                locale === "en"
                    ? "Kalo Unity Sphere in Nürnberg | Advanced | Residential"
                    : "Kalo Unity Sphere in Nürnberg | Advanced | Residential",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate project with Kalo Unity Sphere in Nürnberg."
                    : "FINEXITY realisiert ein weiteres Immobilienprojekt mit der Immobilie Kalo Unity Sphere in Nürnberg.",
            ogImage: `/docs/social/FINEXITY_Kalo_Unity_Sphere_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Kalo_Unity_Sphere_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Kalo_Unity_Sphere_CD_OG.png`,
        },
        "CD-PP-KALONUERNBERG-01-03": {
            ogURL: "/marketplace/CD-PP-KALONUERNBERG-01-03",
            ogTitle:
                locale === "en"
                    ? "Kalo Unity Sphere in Nürnberg | Senior | Residential"
                    : "Kalo Unity Sphere in Nürnberg | Senior | Residential",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate project with Kalo Unity Sphere in Nürnberg."
                    : "FINEXITY realisiert ein weiteres Immobilienprojekt mit der Immobilie Kalo Unity Sphere in Nürnberg.",
            ogImage: `/docs/social/FINEXITY_Kalo_Unity_Sphere_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Kalo_Unity_Sphere_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Kalo_Unity_Sphere_CD_OG.png`,
        },
        "CD-PP-KALONUERNBERG-01-04": {
            ogURL: "/marketplace/CD-PP-KALONUERNBERG-01-04",
            ogTitle:
                locale === "en"
                    ? "Kalo Unity Sphere in Nürnberg | Special-Investor | Residential"
                    : "Kalo Unity Sphere in Nürnberg | Spezial-Investor | Residential",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate project with Kalo Unity Sphere in Nürnberg."
                    : "FINEXITY realisiert ein weiteres Immobilienprojekt mit der Immobilie Kalo Unity Sphere in Nürnberg.",
            ogImage: `/docs/social/FINEXITY_Kalo_Unity_Sphere_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Kalo_Unity_Sphere_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Kalo_Unity_Sphere_CD_OG.png`,
        },
        "CD-PP-KALONUERNBERG-01-05": {
            ogURL: "/marketplace/CD-PP-KALONUERNBERG-01-05",
            ogTitle:
                locale === "en"
                    ? "Kalo Unity Sphere in Nürnberg | Beta | Residential"
                    : "Kalo Unity Sphere in Nürnberg | Beta | Residential",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate project with Kalo Unity Sphere in Nürnberg."
                    : "FINEXITY realisiert ein weiteres Immobilienprojekt mit der Immobilie Kalo Unity Sphere in Nürnberg.",
            ogImage: `/docs/social/FINEXITY_Kalo_Unity_Sphere_CD_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Kalo_Unity_Sphere_CD_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Kalo_Unity_Sphere_CD_OG.png`,
        },
        "CD-PP-DE-HH-12": {
            ogURL: "/marketplace/CD-PP-DE-HH-12",
            ogTitle:
                locale === "en"
                    ? "Überseeallee! HafenCity Bridge | Real Estate Investment"
                    : "Überseeallee! HafenCity Bridge | Immobilieninvestment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realizes the next real estate project in Hamburg. Investors can participate in the form of investment token."
                    : "FINEXITY realisiert das nächste Immobilienprojekt in Hamburg. Anleger können sich in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Ueberseeallee_HafenCity_Bridge_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Ueberseeallee_HafenCity_Bridge_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Ueberseeallee_HafenCity_Bridge_OG.png`,
        },
        "LOUIS-01": {
            ogURL: "/marketplace/LOUIS-01",
            ogTitle:
                locale === "en" ? "SAY 42! Carbon Elite | Yachting Investment" : "SAY 42! Carbon Elite | Yachting Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realizes with SAY 42! Carbon Elite the first yachting investment. Investors can participate in the form of investment token."
                    : "FINEXITY realisiert mit dem Projekt SAY 42! Carbon Elite das erste Yacht-Investment. Anleger können sich in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Louis_SAY42_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Louis_SAY42_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Louis_SAY42_OG.png`,
        },
        "CD-PP-LOUIS-01-01": {
            ogURL: "/marketplace/CD-PP-LOUIS-01-01",
            ogTitle: locale === "en" ? "SAY 42! Junior | Yachting Investment" : "SAY 42! Junior | Yachting Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realizes with SAY 42! Junior the first yachting investment. Investors can participate in the form of investment token."
                    : "FINEXITY realisiert mit dem Projekt SAY 42! Junior das erste Yacht-Investment. Anleger können sich in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Louis_SAY42_Junior_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Louis_SAY42_Junior_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Louis_SAY42_Junior_OG.png`,
        },
        "CD-PP-LOUIS-01-02": {
            ogURL: "/marketplace/CD-PP-LOUIS-01-02",
            ogTitle: locale === "en" ? "SAY 42! Advanced | Yachting Investment" : "SAY 42! Advanced | Yachting Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realizes with SAY 42! Advanced the first yachting investment. Investors can participate in the form of investment token."
                    : "FINEXITY realisiert mit dem Projekt SAY 42! Advanced das erste Yacht-Investment. Anleger können sich in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/FINEXITY_Louis_SAY42_Advanced_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Louis_SAY42_Advanced_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Louis_SAY42_Advanced_OG.png`,
        },
        "CD-PP-AREL-01-01": {
            ogURL: "/marketplace/CD-PP-AREL-01-01",
            ogTitle:
                locale === "en"
                    ? "AREL10! invest from 50.000 EUR | Real Estate Investment"
                    : "AREL10! ab 50.000 EUR | Real Estate Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate project with AREL10! in Bielefeld."
                    : "FINEXITY realisiert ein weiteres Immobilienprojekt mit der Immobilie AREL10! in Bielefeld.",
            ogImage: `/docs/social/FINEXITY_AREL10_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_AREL10_OG.png`,
            twitterImage: `/docs/social/FINEXITY_AREL10_OG.png`,
        },
        "CD-PP-AREL-01-02": {
            ogURL: "/marketplace/CD-PP-AREL-01-02",
            ogTitle:
                locale === "en"
                    ? "AREL10! invest from 150.000 EUR | Real Estate Investment"
                    : "AREL10! ab 150.000 EUR | Real Estate Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate project with AREL10! in Bielefeld."
                    : "FINEXITY realisiert ein weiteres Immobilienprojekt mit der Immobilie AREL10! in Bielefeld.",
            ogImage: `/docs/social/FINEXITY_AREL10_AK_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_AREL10_AK_OG.png`,
            twitterImage: `/docs/social/FINEXITY_AREL10_AK_OG.png`,
        },
        "CD-PP-AREL-02-01": {
            ogURL: "/marketplace/CD-PP-AREL-02-01",
            ogTitle:
                locale === "en"
                    ? "Am Sportplatz! Bielefeld invest from 5.000 EUR | Real Estate Investment"
                    : "Am Sportplatz! Bielefeld ab 5.000 EUR investieren | Real Estate Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate project with Am Sportplatz! in Bielefeld."
                    : "FINEXITY realisiert ein weiteres Immobilienprojekt mit der Immobilie Am Sportplatz! in Bielefeld.",
            ogImage: `/docs/social/FINEXITY_Am_Sportplatz_Junior_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Am_Sportplatz_Junior_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Am_Sportplatz_Junior_OG.png`,
        },
        "CD-PP-AREL-02-02": {
            ogURL: "/marketplace/CD-PP-AREL-02-02",
            ogTitle:
                locale === "en"
                    ? "Am Sportplatz! Bielefeld invest from 25.000 EUR | Real Estate Investment"
                    : "Am Sportplatz! Bielefeld ab 25.000 EUR investieren | Real Estate Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate project with Am Sportplatz! in Bielefeld."
                    : "FINEXITY realisiert ein weiteres Immobilienprojekt mit der Immobilie Am Sportplatz! in Bielefeld.",
            ogImage: `/docs/social/FINEXITY_Am_Sportplatz_Advanced_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Am_Sportplatz_Advanced_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Am_Sportplatz_Advanced_OG.png`,
        },
        "CD-PP-AREL-02-03": {
            ogURL: "/marketplace/CD-PP-AREL-02-03",
            ogTitle:
                locale === "en"
                    ? "Am Sportplatz! Bielefeld invest from 100.000 EUR | Real Estate Investment"
                    : "Am Sportplatz! Bielefeld ab 100.000 EUR investieren | Real Estate Investment",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realises the next real estate project with Am Sportplatz! in Bielefeld."
                    : "FINEXITY realisiert ein weiteres Immobilienprojekt mit der Immobilie Am Sportplatz! in Bielefeld.",
            ogImage: `/docs/social/FINEXITY_Am_Sportplatz_Special_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Am_Sportplatz_Special_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Am_Sportplatz_Special_OG.png`,
        },
        "CD-PP-FRD-02-01": {
            ogURL: "/marketplace/CD-PP-FRD-02-01",
            ogTitle: locale === "en" ? "Ocean View! Junior | Holiday Apartments" : "Ocean View! Junior | Ferienimmobilie",
            ogDescription:
                locale === "en"
                    ? "FINEXITY expands its product offering with Ocean View! Junior."
                    : "FINEXITY erweitert sein Produktangebot um eine Ferienimmobilie Ocean View! Junior",
            ogImage: `/docs/social/FINEXITY_FRD_Ocean_View_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_FRD_Ocean_View_OG.png`,
            twitterImage: `/docs/social/FINEXITY_FRD_Ocean_View_OG.png`,
        },
        "CD-PP-FRD-02-02": {
            ogURL: "/marketplace/CD-PP-FRD-02-02",
            ogTitle: locale === "en" ? "Ocean View! Advanced | Holiday Apartments" : "Ocean View! Advanced | Ferienimmobilie",
            ogDescription:
                locale === "en"
                    ? "FINEXITY expands its product offering with Ocean View! Advanced."
                    : "FINEXITY erweitert sein Produktangebot um eine Ferienimmobilie Ocean View! Advanced",
            ogImage: `/docs/social/FINEXITY_FRD_Ocean_View_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_FRD_Ocean_View_OG.png`,
            twitterImage: `/docs/social/FINEXITY_FRD_Ocean_View_OG.png`,
        },
        "CD-PP-FRD-02-03": {
            ogURL: "/marketplace/CD-PP-FRD-02-03",
            ogTitle: locale === "en" ? "Ocean View! Senior | Holiday Apartments" : "Ocean View! Senior | Ferienimmobilie",
            ogDescription:
                locale === "en"
                    ? "FINEXITY expands its product offering with Ocean View! Senior."
                    : "FINEXITY erweitert sein Produktangebot um eine Ferienimmobilie Ocean View! Senior",
            ogImage: `/docs/social/FINEXITY_FRD_Ocean_View_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_FRD_Ocean_View_OG.png`,
            twitterImage: `/docs/social/FINEXITY_FRD_Ocean_View_OG.png`,
        },
        "CD-PP-FRD-02-04": {
            ogURL: "/marketplace/CD-PP-FRD-02-04",
            ogTitle: locale === "en" ? "Ocean View! Anker | Holiday Apartments" : "Ocean View! Anker | Ferienimmobilie",
            ogDescription:
                locale === "en"
                    ? "FINEXITY expands its product offering with Ocean View! Anker."
                    : "FINEXITY erweitert sein Produktangebot um eine Ferienimmobilie Ocean View! Anker",
            ogImage: `/docs/social/FINEXITY_FRD_Ocean_View_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_FRD_Ocean_View_OG.png`,
            twitterImage: `/docs/social/FINEXITY_FRD_Ocean_View_OG.png`,
        },
        "NEU26-01": {
            ogURL: "/marketplace/NEU26-01",
            ogTitle:
                locale === "en" ? "Secondary Cash Pool Alpha Retail | Cash Pool" : "Secondary Cash Pool Alpha Retail | Cash Pool",
            ogDescription:
                locale === "en"
                    ? "FINEXITY expands its product offering with Secondary Cash Pool Alpha Retail."
                    : "FINEXITY erweitert sein Produktangebot mit dem Secondary Cash Pool Alpha Retail",
            ogImage: `/docs/social/FINEXITY_Secondary_Market_Cash_Pool_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Secondary_Market_Cash_Pool_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Secondary_Market_Cash_Pool_OG.png`,
        },
        "CD-PP-NEU26-01-01": {
            ogURL: "/marketplace/CD-PP-NEU26-01-01",
            ogTitle:
                locale === "en" ? "Secondary Cash Pool Alpha Junior | Cash Pool" : "Secondary Cash Pool Alpha Junior | Cash Pool",
            ogDescription:
                locale === "en"
                    ? "FINEXITY expands its product offering with Secondary Cash Pool Alpha Junior."
                    : "FINEXITY erweitert sein Produktangebot mit dem Secondary Cash Pool Alpha Junior",
            ogImage: `/docs/social/FINEXITY_Secondary_Market_Cash_Pool_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Secondary_Market_Cash_Pool_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Secondary_Market_Cash_Pool_OG.png`,
        },
        "CD-PP-NEU26-01-02": {
            ogURL: "/marketplace/CD-PP-NEU26-01-02",
            ogTitle:
                locale === "en"
                    ? "Secondary Cash Pool Alpha Advanced | Cash Pool"
                    : "Secondary Cash Pool Alpha Advanced | Cash Pool",
            ogDescription:
                locale === "en"
                    ? "FINEXITY expands its product offering with Secondary Cash Pool Alpha Advanced."
                    : "FINEXITY erweitert sein Produktangebot mit dem Secondary Cash Pool Alpha Advanced",
            ogImage: `/docs/social/FINEXITY_Secondary_Market_Cash_Pool_OG.png`,
            ogImageURL: `/docs/social/FINEXITY_Secondary_Market_Cash_Pool_OG.png`,
            twitterImage: `/docs/social/FINEXITY_Secondary_Market_Cash_Pool_OG.png`,
        },
    };

    const defaultMetaTags = {
        [TENANTS_LIST.SACHWERTINVEST]: {
            ogTitle: "Sachwert Invest",
            ogDescription:
                "Die digitale Investmentplattform der Sparkasse in alternative Anlageklassen. Wir ermöglichen es Dir, schon ab 500€ in Sachwerte zu investieren, z.B. in Immobilien, erneuerbare Energien, Wein und Kunst.",
            ogImage: `/images/SI-default-ogimage.jpg`,
            ogImageURL: `/images/SI-default-ogimage.jpg`,
        },
        other: {
            ogTitle:
                locale === "en" ? "Investing in digital real assets | FINEXITY" : "Investition in digitale Sachwerte | FINEXITY",
            ogDescription:
                locale === "en"
                    ? "FINEXITY realizes the next digital alternative asset investment. Investors can participate in the form of investment tokens from 500 euros."
                    : "FINEXITY realisiert die nächste digitale Sachwertinvestition. Anleger können sich ab 500 Euro in Form von Investment-Token beteiligen.",
            ogImage: `/docs/social/MarketplaceOG.png`,
            ogImageURL: `/docs/social/MarketplaceOG.png`,
            twitterImage: `/docs/social/MarketplaceOG.png`,
        },
    };

    return metaTags[projectID] || defaultMetaTags[currentTenant] || defaultMetaTags["other"];
};
